{
  "zh-TW": {
    "labels": {
      "saved": "已儲存",
      "hangarShare": {
        "intro": "建立一個私密連結，即使你的機庫設為私密，拿到連結的人也能查看你的機庫及其統計資料。你的願望清單仍依照其自身的設定。",
        "howTo": "任何擁有此連結的人都能查看你的機庫。重設連結可讓持有目前連結的人失去存取權限，刪除連結則停止分享。"
      },
      "locationInput": {
        "linked": "已連結到"
      },
      "galactapedia": "Galactapedia",
      "shopPage": {
        "all": "全部",
        "search": "在此商店中搜尋",
        "categories": "類別",
        "sortName": "名稱",
        "sortPrice": "價格",
        "emptyName": "物品",
        "kind": "商店",
        "items": "商品",
        "facts": "關鍵資訊",
        "place": "地點",
        "system": "星系",
        "carries": "出售",
        "source": "價格與庫存來自 UEX。"
      },
      "location": {
        "missionsSample": "計數僅涵蓋 %{total} 個中的前 %{shown} 個。",
        "people": "在此的好友與艦隊成員",
        "peopleFriend": "好友",
        "peopleUnlisted": "另有 %{count} 人未列出",
        "systemUnavailable": "無法載入此星系。",
        "systemsUnavailable": "無法載入星系。",
        "resourceKinds": {
          "ship_mineables": "飛船採礦",
          "hand_mineables": "手持採礦",
          "ground_vehicle_mineables": "地面載具採礦",
          "harvestables": "可採集物",
          "creatures": "生物"
        },
        "resources": "資源",
        "moonsBadge": "衛星",
        "planets": "行星",
        "places": "地點",
        "showFewer": "收合",
        "showAll": "顯示全部 %{count} 個",
        "elsewhere": "%{star} 周圍的其他地方",
        "namesakes": "×%{count}",
        "lagrangePoints": "拉格朗日點",
        "inOrbit": "軌道上",
        "moons": {
          "one": "%{count} 顆衛星",
          "other": "%{count} 顆衛星"
        },
        "gateways": "跳躍門",
        "jumpPoints": "跳躍點",
        "notInGameYet": "尚未加入遊戲",
        "jumpLegend": {
          "title": "跳躍連接",
          "inGame": "遊戲中",
          "temporary": "臨時",
          "planned": "計畫中"
        },
        "systemStrip": "%{system}，從恆星向外",
        "allSystems": "所有星系",
        "allPlaces": "所有地點",
        "shops": "商店",
        "shopItems": {
          "one": "%{count} 件商品",
          "other": "%{count} 件商品"
        },
        "shopItemTypes": {
          "Model": "艦船",
          "ModelModule": "模組",
          "ModelPaint": "塗裝",
          "Component": "組件",
          "Equipment": "裝備",
          "Commodity": "商品"
        },
        "bodyTypes": {
          "gas_giant": "氣態巨行星",
          "ice_giant": "冰巨星",
          "asteroid": "小行星",
          "city": "城市星球"
        },
        "unstable": "不穩定",
        "unstableHint": "閃焰星：其輻射會毫無預警地驟增。",
        "systems": "星系",
        "name": "名稱",
        "kind": "類型",
        "retired": "不在此版本中",
        "starmap": "星圖",
        "starmapVisibility": "遊戲內地圖",
        "starmapHidden": "在地圖上隱藏",
        "starmapAlways": "始終顯示在地圖上",
        "starmapWithParent": "選取 %{parent} 後顯示",
        "starmapShown": "顯示在地圖上",
        "quantumTravel": "量子旅行",
        "quantumTravelYes": "是",
        "quantumTravelNo": "否",
        "mapParent": "地圖上位於",
        "mapParentNote": "遊戲內地圖將其顯示在 %{mapParent} 下，但它實際位於 %{parent} 內。",
        "missions": "任務",
        "allMissions": "所有可在此進行的任務",
        "terminals": "交易終端",
        "alwaysShown": "始終在地圖上",
        "hiddenOnStarmap": "在地圖上隱藏",
        "facilities": "起降",
        "hangars": "機庫",
        "hangarsNote": "每個機庫依飛行員個別實例化：計算的是機庫門，而非泊位。",
        "landingPads": "著陸平台",
        "freeLandingPads": "自由著陸平台",
        "freeLandingPadsNote": "無需 ATC 指派平台即可降落。",
        "vehiclePads": "地面載具平台",
        "dockingTubes": "對接艙口",
        "kinds": {
          "system": "星系",
          "star": "恆星",
          "planet": "行星",
          "moon": "衛星",
          "city": "城市",
          "spaceport": "太空港",
          "station": "太空站",
          "outpost": "前哨站",
          "clinic": "診所",
          "district": "街區",
          "asteroid": "小行星",
          "anomaly": "異常點",
          "jump_point": "跳躍點",
          "point_of_interest": "興趣點",
          "nav_point": "導航點",
          "other": "其他"
        },
        "setLocation": "設定位置",
        "myLocation": "我的位置",
        "shipLocation": "飛船位置",
        "setLocationSuccess": "位置已更新。",
        "setLocationFailure": "無法更新位置。"
      },
      "sortOptions": "排序選項",
      "loading": "載入中…",
      "loadingNamed": "正在載入 %{name}…",
      "true": "是",
      "false": "否",
      "null": "-",
      "presets": {
        "title": "選擇圖片",
        "filter": "類型",
        "all": "全部",
        "empty": "沒有可用的圖片。"
      },
      "maintainer": {
        "badge": "維護者",
        "tooltip": "維護 FleetYards.net"
      },
      "supporter": {
        "badge": "支持者",
        "tooltip": "本月支持 FleetYards.net",
        "none": "非支持者",
        "fleetTierUntil": "艦隊等級至 %{date}",
        "fleetTierExpired": "已過期",
        "fleetTierOngoing": "訂閱持續期間享有艦隊等級",
        "until": "有效期至 %{date}",
        "expiring": "%{date} 到期",
        "ongoing": "定期支持，無結束日期",
        "tierShort": "第 %{tier} 級"
      },
      "destroyedFleets": {
        "discarded": "已捨棄",
        "purged": "已清除"
      },
      "and": "和",
      "hide": "隱藏",
      "show": "顯示",
      "only": "僅",
      "description": "描述",
      "unavailable": "不可用",
      "selected": "已選擇",
      "actions": "操作",
      "status": "狀態",
      "enabled": "已啟用",
      "disabled": "已禁用",
      "collapse": "摺疊",
      "price": "價格",
      "expand": "展開",
      "distance": "距離",
      "anonymous": "匿名",
      "refreshing": "正在重新載入...",
      "toggleNavigation": "切換導航",
      "openInNewWindow": "全螢幕開啟",
      "or": "或",
      "groups": "分組",
      "classifications": "分類",
      "features": {
        "stateOn": "已啟用",
        "stateOff": "已停用",
        "stateConditional": "有條件",
        "openFor": "已開放 %{days} 天",
        "historyEmpty": "尚未記錄此功能的任何變更。",
        "historyBy": "由 %{actor}",
        "sources": {
          "admin": "管理後台",
          "self_service": "自助",
          "sync": "部署",
          "console": "主控台",
          "backfill": "回填"
        },
        "selfService": "自助服務",
        "actors": "角色",
        "groups": "群組",
        "noGroups": "此功能沒有啟用的群組。",
        "noActors": "此功能沒有啟用的個人角色。",
        "user": "使用者",
        "fleet": "艦隊",
        "actorType": "角色類型",
        "percentageOfActors": "的角色",
        "percentageOfTime": "的時間",
        "currentState": "目前狀態",
        "toggle": "切換",
        "permanent": "長期",
        "tabs": {
          "all": "全部",
          "rollout": "灰度發布",
          "permanent": "長期"
        },
        "settingsIntro": "為您的帳戶啟用或停用實驗性功能。這些功能可能不完整或隨時變更。",
        "registryHint": "功能旗標宣告於 config/feature_flags.yml，並在部署時建立。你可以在這裡控制它們的開放範圍。",
        "fleetSettingsIntro": "為整個艦隊啟用或停用功能。您在此啟用的內容對所有成員可見。",
        "fleetFeature": "艦隊功能",
        "fleetFeatureInfo": "在此啟用僅對您生效。您艦隊的管理員可為整個艦隊啟用。",
        "toggleForSelf": "僅為自己切換",
        "fleetFeatureGrantedShort": "艦隊已啟用",
        "fleetFeatureGranted": "您的艦隊已為所有成員啟用此功能，因此無法在此處關閉。",
        "groupFeatureGrantedShort": "群組已啟用",
        "groupFeatureGranted": "您所在的某個群組已啟用此功能，因此無法在此處關閉。",
        "groupFeatureGrantedFleet": "該艦隊所在的某個群組已啟用此功能，因此無法在此處關閉。",
        "managedFeatureShort": "受管理",
        "managedFeature": "此功能已為您的帳戶啟用，無法在此處變更。",
        "managedFeatureFleet": "此功能已為該艦隊啟用，無法在此處變更。",
        "selfServiceUser": "使用者可自行切換",
        "selfServiceFleet": "艦隊管理員可切換",
        "globalHint": "開啟後對所有人開放此功能。關閉會清除所有規則，包括下方的使用者、艦隊和群組。",
        "selfServiceHint": "誰可以自行開啟此功能。",
        "lastChanged": "最後修改於 %{date}",
        "filterUsers": "依使用者名稱篩選",
        "filterFleets": "依名稱或 SID 篩選",
        "noUsers": "沒有使用者個別啟用此功能。",
        "noFleets": "沒有艦隊個別啟用此功能。",
        "noMatches": "沒有符合篩選條件的結果。",
        "memberCount": "%{count} 名成員",
        "alreadyEnabled": "該艦隊已啟用此功能。"
      },
      "oauthApplication": {
        "name": "應用程式名稱",
        "clientId": "客戶端 ID",
        "clientSecret": "客戶端密鑰",
        "redirectUri": "重導向 URI",
        "redirectUriHint": "每行一個 URI。",
        "confidential": "機密",
        "scopes": "權限範圍",
        "scopesHint": "如果未選擇權限範圍，將使用預設範圍: %{scopes}",
        "logo": "圖示",
        "logoHint": "顯示在授權頁面上，方便使用者辨認你的應用程式。支援 PNG、JPG、GIF 或 WebP。"
      },
      "rsiRequestLogs": {
        "resolved": "已解決",
        "unresolved": "未解決"
      },
      "imports": {
        "type": "類型",
        "status": "狀態",
        "version": "版本",
        "startedAt": "開始於",
        "finishedAt": "完成於",
        "failedAt": "失敗於",
        "info": "資訊",
        "input": "輸入",
        "output": "輸出",
        "importData": "匯入資料",
        "file": "匯入的檔案",
        "requestedBy": "要求者",
        "adminUser": "管理員使用者",
        "user": "使用者",
        "includeSystem": "包含系統",
        "systemRequester": "系統",
        "statuses": {
          "created": "排隊中",
          "started": "執行中",
          "finished": "已完成",
          "failed": "失敗",
          "cancelled": "已取消"
        },
        "targetGroupHint": "選擇一個機庫分組，所有匯入的艦船都會歸入其中。留空則使用檔案中指定的分組。",
        "types": {
          "Imports::HangarImport": "機庫匯入",
          "Imports::HangarSync": "RSI 機庫同步",
          "Imports::BuybackSync": "RSI 回購同步"
        },
        "summary": {
          "imported": "已匯入",
          "missing": "未找到",
          "found": "已配對"
        },
        "formatHint": "支援三種檔案格式：",
        "formats": {
          "fleetyards": "FleetYards 機庫匯出檔 —— 使用匯出按鈕即可產生。",
          "hangarXplor": "hangarXPLOR 匯出檔。",
          "hangarExtension": "Star Citizen: Hangar Extension 瀏覽器擴充功能的 JSON 匯出檔。"
        },
        "details": {
          "imported": "已新增",
          "found": "已配對",
          "movedToWanted": "已移至願望清單",
          "deleted": "已刪除",
          "grouped": "已歸入分組",
          "unchanged": "保持不變",
          "missing": "未找到的艦船",
          "missingComponents": "未找到的元件",
          "missingUpgrades": "未找到的升級"
        },
        "noDetails": "本次執行未記錄詳情。"
      },
      "oauthApplications": {
        "settingsIntro": "管理您的 OAuth 應用程式。這些應用程式可以代表使用者存取 FleetYards API。",
        "name": "應用程式名稱",
        "redirectUri": "重導向 URI",
        "confidential": "機密",
        "clientId": "客戶端 ID",
        "clientSecret": "客戶端密鑰",
        "scopes": "權限範圍",
        "defaultScopes": "預設權限範圍",
        "confidentialShort": "機密",
        "publicShort": "公開",
        "logo": "圖示",
        "state": "狀態",
        "rejectionReason": "拒絕原因",
        "statePending": "等待審核",
        "stateApproved": "已核准",
        "stateRejected": "已拒絕",
        "reviewedBy": "審核者",
        "owner": "註冊者"
      },
      "fleetInviteToken": "艦隊邀請",
      "inviteToken": "邀請碼",
      "scDataVersion": "補丁版本",
      "title": "標題",
      "createdAt": "建立於",
      "updatedAt": "更新於",
      "addToHangar": "新增到機庫",
      "home": {
        "search": "搜尋飛船..."
      },
      "shop": {
        "sellPrice": "出售價格",
        "buyPrice": "購買價格"
      },
      "shopCommodity": {
        "item": "項目",
        "shop": "商店",
        "buyPrices": "購買價格",
        "rentalPrices": "租賃價格",
        "confirmed": "已確認？",
        "prices": {
          "label": "價格",
          "sellPrice": "出售價格",
          "buyPrice": "購買價格"
        }
      },
      "statsCard": {
        "stock": "原廠：%{value}",
        "more": "詳情頁另有 %{count} 項",
        "unavailable": "無法載入這些詳情。",
        "loading": "正在載入 %{name}…",
        "offeredBy": "由 %{name} 提供",
        "rsiHandle": "RSI 使用者名稱 %{handle}",
        "types": {
          "Component": "組件",
          "Equipment": "裝備",
          "Commodity": "商品",
          "Model": "艦船",
          "Blueprint": "藍圖",
          "GameMission": "任務",
          "Location": "地點",
          "FleetContract": "合約",
          "FleetEvent": "活動",
          "User": "使用者",
          "FleetMember": "成員"
        },
        "open": {
          "Component": "開啟組件",
          "Equipment": "開啟裝備",
          "Commodity": "開啟商品",
          "Model": "開啟艦船",
          "Blueprint": "開啟藍圖",
          "GameMission": "開啟任務",
          "Location": "開啟地點",
          "FleetContract": "開啟合約",
          "FleetEvent": "開啟活動",
          "User": "開啟機庫",
          "FleetMember": "在成員列表中查看"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "%{year} 年新飛船",
          "totalShips": "飛船總數",
          "totalMembers": "成員總數",
          "vehicles": "機庫飛船",
          "wishlists": "願望清單飛船",
          "shipOfTheMonth": "月度飛船"
        },
        "modelsByClassification": "按分類劃分的飛船",
        "modelsBySize": "按大小劃分的飛船",
        "vehiclesByModel": "按型號劃分的飛船 (前 %{limit})",
        "modelsPerMonth": "每月飛船數量",
        "modelsByManufacturer": "按製造商劃分的飛船",
        "modelsByProductionStatus": "按生產狀態劃分的飛船",
        "vehiclesPerMonth": "每月機庫飛船",
        "topVehiclesByModel": "前 10 機庫飛船",
        "shipsOfTheMonth": "月度飛船",
        "trendingShips": "瀏覽最多的飛船（30 天）",
        "wishlistByModel": "最受期待的飛船",
        "wishToOwnRatio": "每 100 艘擁有對應的期待數",
        "topPaints": "最受歡迎的塗裝",
        "paintedVehicles": "已塗裝飛船",
        "pledgePriceChanges": "現金購買價變動（12 個月）",
        "ingamePriceChanges": "遊戲內價格變動（30 天）",
        "mostWishlisted": "本月最受期待的飛船",
        "patchChanges": "本次更新改動最大的飛船",
        "crewDeficit": "船員缺口",
        "crewSurplus": "船員盈餘",
        "membersByRole": "按角色分組成員",
        "csv": {
          "metric": "指標",
          "value": "數值",
          "count": "數量"
        }
      },
      "roadmap": {
        "releases": "發佈",
        "released": "已發佈",
        "lastVersion": {
          "active": {
            "false": "條目已從路線圖移除",
            "true": "條目已重新新增到路線圖"
          },
          "released": "項目已發佈到 PU",
          "release": "項目從版本 %{old} 移動到 %{new}"
        },
        "stories": {
          "one": "%{count} 個故事",
          "other": "%{count} 個故事"
        },
        "tasks": {
          "one": "%{count} 個任務",
          "other": "%{count} 個任務"
        },
        "ships": {
          "one": "%{count} 艘飛船",
          "other": "%{count} 艘飛船"
        }
      },
      "unknown": "未知",
      "none": "-",
      "notAvailable": "不可用",
      "not-available": "不可用",
      "name": "名稱",
      "homepage": "首頁",
      "discord": "Discord 伺服器",
      "youtube": "YouTube 頻道",
      "twitch": "Twitch 頻道",
      "guilded": "Guilded 伺服器",
      "3dView": "3D",
      "3dMap": "Map",
      "texturedHolo": "材質",
      "viewInAr": "AR",
      "viewInArHint": "以真實尺寸放置在你的房間中",
      "filter": "篩選",
      "taxExcluded": "不含稅",
      "hangar": "機庫",
      "public": "公開",
      "hangarStats": "統計",
      "wishlist": "願望清單",
      "fleetchart": "艦隊圖表",
      "fleetchartScale": "艦船比例",
      "fleetchartApp": {
        "screenHeight": "螢幕高度",
        "viewpoint": "視角",
        "screenHeightOptions": {
          "auto": "自動",
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "port": "左舷",
          "top": "頂部",
          "angled": "斜角",
          "front": "正面"
        },
        "gridSize": "每格 %{size} 公尺",
        "mode": "模式",
        "modeOptions": {
          "classic": "經典",
          "panzoom": "v2"
        }
      },
      "fleetStats": "統計",
      "hangarMetrics": {
        "total": "總計",
        "totalMoney": "Money Value",
        "totalCredits": "Credits",
        "totalIngameValue": "機庫 aUEC 價值",
        "totalCrew": "船員",
        "totalCargo": "總貨物",
        "largestShip": "最大飛船",
        "smallestShip": "最小飛船",
        "averagePledgePrice": "平均質押價格",
        "flightReady": "可飛行",
        "uniqueModels": "獨特型號",
        "manufacturerCount": "製造商",
        "missingClassifications": "缺失角色",
        "wishlistTotalMoney": "願望清單質押價值",
        "wishlistTotalCredits": "願望清單遊戲內價值"
      },
      "selectModel": "選擇飛船",
      "findModel": "輸入以查找飛船",
      "find": "輸入以搜尋",
      "selectUser": "選擇使用者",
      "findUser": "輸入以搜尋使用者",
      "selectAdminUser": "選擇管理員使用者",
      "selectFleet": "選擇艦隊",
      "findFleet": "輸入以搜尋艦隊",
      "compare": {
        "removeModel": "移除飛船",
        "addModel": {
          "nullablePrompt": "新增飛船"
        },
        "enough": "Don't you think 8 Ships are enough? ;)",
        "shipCount": {
          "one": "%{count} 艘飛船",
          "other": "%{count} 艘飛船"
        },
        "containersOfSize": "%{size} SCU 貨櫃",
        "armorHp": "裝甲 HP",
        "fuelAndQuantum": "燃料與量子",
        "weaponPoolSize": "武器能量池",
        "crossSection": {
          "x": "截面 X",
          "y": "截面 Y",
          "z": "截面 Z"
        },
        "useAsBaseline": "設為基準",
        "baseline": "基準",
        "differencesOnly": "僅顯示差異",
        "compareToBaseline": "與基準比較",
        "loadoutBySlot": "依掛載槽顯示配置",
        "slots": {
          "guns": "主武器",
          "turrets": "砲塔",
          "missiles": "飛彈",
          "shields": "護盾產生器",
          "powerPlants": "發電機",
          "coolers": "冷卻器",
          "quantumDrives": "量子引擎",
          "thrusters": "主推進器",
          "countermeasures": "反制措施"
        },
        "legend": {
          "best": "本列最佳",
          "worst": "最差",
          "share": "佔本列最佳值的比例",
          "better": "優於基準",
          "worse": "落後基準"
        },
        "selectShips": "選擇飛船"
      },
      "au": "AU",
      "uec": "aUEC",
      "sell": "賣出",
      "buy": "買入",
      "yourFlagship": "您的旗艦",
      "flagship": "旗艦",
      "fleet": {
        "headquarters": "總部",
        "index": "艦隊",
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "艦隊",
        "fid": "艦隊 ID",
        "name": "名稱",
        "logo": "標誌",
        "rsiSid": "SID",
        "rsiSettings": {
          "hint": "艦隊 ID 是你的艦隊在 Fleetyards 上的網址。SID 將艦隊與其 RSI 組織連結，驗證它可以證明該組織屬於你。"
        },
        "fidClaim": {
          "claimableTitle": "申領艦隊 ID %{fid}",
          "claimable": "你的艦隊已通過 RSI 組織 %{fid} 的驗證，但艦隊 ID %{fid} 由另一支艦隊持有。申領後，該艦隊有 14 天時間自行證明該組織或通知其成員。之後它將被改名，%{fid} 成為你的艦隊 ID。",
          "pendingTitle": "對 %{fid} 的申領進行中",
          "pending": "%{holder} 將保留 %{fid} 至 %{date}。之後該 ID 轉給你的艦隊，除非該艦隊在此之前證明它在管理組織 %{fid}。",
          "availableTitle": "艦隊 ID %{fid} 空閒",
          "available": "你的艦隊已通過 %{fid} 的驗證，且沒有其他艦隊使用該 ID。請在上方將其設為你的艦隊 ID。",
          "incomingTitle": "%{claimant} 申領你的艦隊 ID",
          "incoming": "%{claimant} 已通過 RSI 組織 **%{fid}** 的驗證。\n\n**%{date}：**\n\n- 你的艦隊將改用下一個空閒艦隊 ID，例如 **%{fid}-1**。\n- 此後指向 %{fid} 的連結會開啟 %{claimant}。\n\n**如需保留該 ID**，請在此之前驗證 %{fid}；否則請通知你的成員網址即將變更。",
          "createTakenTitle": "%{fid} 已被使用",
          "createTaken": "如果 %{fid} 是你的 RSI 組織，請先使用 %{suggestion} 並填寫 SID %{fid}。你的艦隊通過 %{fid} 的驗證後，即可從持有該 ID 的艦隊申領它。"
        },
        "rsiVerification": {
          "extension": {
            "title": "使用 FleetYards Sync 擴充功能驗證",
            "verify": "使用擴充功能驗證",
            "description": "擴充功能會將驗證碼加入你的組織在 RSI 上的歷史並發布，檢查頁面，然後再將驗證碼移除。",
            "detecting": "正在尋找 FleetYards Sync 擴充功能",
            "install": "安裝 FleetYards Sync 擴充功能，即可一鍵驗證你的艦隊。",
            "update": "更新 FleetYards Sync 擴充功能即可一鍵驗證你的艦隊：目前安裝的版本尚不支援。",
            "notSignedIn": "請在此瀏覽器中使用可以編輯 %{sid} 的帳號登入 RSI，或在下方手動驗證。",
            "noRights": "此瀏覽器登入的 RSI 帳號無法編輯 %{sid} 的頁面。請使用軍官帳號登入，或在下方手動驗證。",
            "pendingChanges": "%{sid} 在 RSI 上有未發布的變更。請先發布或清除該草稿，以免擴充功能發布他人的修改，或在下方手動驗證。",
            "orgUnreadable": "擴充功能無法讀取 %{sid} 在 RSI 上的頁面。請在下方手動驗證。",
            "failed": "擴充功能無法更新 %{sid} 的頁面。請重試，或在下方手動驗證。",
            "removeFailed": "擴充功能無法從 %{sid} 的歷史中移除驗證碼。請在那裡手動移除。",
            "manual": "或手動驗證："
          },
          "steps": {
            "copy": "複製你的驗證碼",
            "paste": "將它貼到你的組織 RSI 公開頁面的任意位置：簡介、歷史、宣言或章程。艦隊驗證後即可將其刪除。",
            "check": "檢查頁面"
          },
          "openOrgPage": "在 RSI 上開啟 %{sid}",
          "fidAtRiskTitle": "你的艦隊 ID 未受保護",
          "saveFirst": "請先儲存 SID 再進行驗證。",
          "title": "RSI 驗證",
          "token": "驗證碼",
          "verified": "已驗證的 RSI 組織",
          "unverified": "未通過 RSI 驗證",
          "verifiedSince": "自 %{date} 起已驗證",
          "nextCheck": "一分鐘後可以再次檢查。",
          "fidAtRisk": "驗證 RSI 組織 %{fid} 的另一支艦隊可以認領它，你的艦隊網址將會改變。",
          "statuses": {
            "pending": "正在檢查組織頁面…",
            "token_missing": "組織頁面上還沒有該驗證碼。RSI 可能需要幾分鐘才會顯示修改。",
            "symbol_mismatch": "RSI 回傳的頁面屬於另一個組織。",
            "not_found": "RSI 上沒有使用此 SID 的組織。",
            "failed": "無法檢查組織頁面。請一分鐘後重試。"
          }
        },
        "description": "描述",
        "public": "公開艦隊檢視",
        "publicFleet": "公開艦隊",
        "publicStats": "公開統計",
        "publicFleetStats": "公開艦隊統計",
        "discord": {
          "url": "Discord 伺服器",
          "hint": "連接 Discord 伺服器，即可把活動同步成 Discord 原生的排程活動。成員可以直接在 Discord 上回覆出席，報名資料會同步回 Fleetyards。",
          "guildId": "Discord 伺服器 ID",
          "channelId": "語音頻道 ID（選填）",
          "webhookUrl": "公告 Webhook 網址（選填）",
          "installBotHint": "會在新分頁開啟 Discord 安裝頁面 — 請選擇你要同步活動的伺服器。",
          "announcementChannel": "公告頻道",
          "announcementChannelHint": "新活動與即將開始的提醒會發布在這裡。未設定時透過 Webhook 發送。僅限中隊的活動會改為發布在該中隊的頻道。",
          "officersChannel": "軍官頻道",
          "officersChannelHint": "僅軍官可見的活動會在這裡公告，不會出現在 Discord 的其他地方。未設定時不會在 Discord 上公告。加入申請也會發布在這裡，並附有接受或拒絕的按鈕。",
          "digestWeekday": "每週摘要",
          "digestWeekdayHint": "每週一次，每個頻道會收到它可見的未來七天活動清單。留空即可關閉。",
          "digestTime": "摘要時間",
          "digestTimeHint": "使用你的時區（%{timezone}）。",
          "channelMissing": "此頻道在 Discord 上已不存在或無法再發文。選擇其他頻道之前不會發布任何內容。",
          "missingChannel": "無法使用的頻道",
          "joinRole": "加入身分組",
          "joinRoleHint": "在伺服器中擁有此身分組的玩家無需申請即可加入艦隊，並獲得預設職級。移除該身分組後，透過它加入的成員也會被移出艦隊。留空則手動審核每個申請。",
          "roleMissing": "此身分組在 Discord 上已不存在。在選擇其他身分組之前，任何人都無法透過它加入。",
          "missingRole": "無法使用的身分組",
          "saveGuildFirst": "請先儲存新的伺服器，再選擇它的頻道和身分組。",
          "roleMapping": "Discord 身分組",
          "roleMappingHint": "Fleetyards 會在伺服器中給成員這些身分組，並在成員變更軍階或離開艦隊時收回。它只會新增或移除這裡選擇的身分組。",
          "memberRole": "成員身分組",
          "memberRoleHint": "艦隊的每位成員都會獲得此身分組，與軍階無關。",
          "rolesCodes": {
            "missing_manage_roles": "機器人無權在此伺服器中管理身分組。請使用安裝連結重新授權。",
            "unknown_role": "這裡選擇的身分組在 Discord 上已不存在：%{names}。",
            "role_above_bot": "機器人無法分配 %{names}：Discord 只允許它分配低於自身的身分組。請在伺服器設定中將機器人的身分組移到它們之上。"
          },
          "postingCodes": {
            "missing_send_messages": "機器人無權在此伺服器傳送訊息。請透過安裝連結重新授權。",
            "channel_locked": "機器人無法在為 %{names} 選擇的頻道中發文。請在該頻道的權限中允許。",
            "unknown_channel": "為 %{names} 選擇的頻道在 Discord 上已不存在或無法再發文。",
            "channel_shared": "%{names} 與看不到其活動的讀者共用一個頻道。在各自擁有專屬頻道之前，不會在那裡發布任何內容。"
          },
          "joinRoleCodes": {
            "members_intent_missing": "Fleetyards 機器人暫時無法列出此伺服器的成員，因此加入身分組只在玩家使用邀請連結時生效。請聯絡管理員。",
            "live_updates_off": "身分組變更每天只同步到 Fleetyards 一次：機器人沒有即時監聽這些變更。請聯絡管理員。",
            "bot_offline": "Fleetyards 機器人目前未連線到 Discord，因此身分組變更會等到每日同步時處理。請聯絡管理員。"
          },
          "statusOk": "已連線至 %{name}",
          "statusCodes": {
            "missing_token": "伺服器端尚未設定 Fleetyards 機器人。請聯絡管理員。",
            "missing_guild": "請先輸入 Discord 伺服器 ID。",
            "invalid_token": "機器人權杖無效。請聯絡管理員。",
            "bot_not_in_guild": "機器人不在這個伺服器裡。請使用安裝連結把它加進去。",
            "guild_not_found": "Discord 無法辨識這個伺服器 ID。請再次確認輸入的值。",
            "discord_error": "Discord 回傳了非預期的錯誤。",
            "request_failed": "無法連線到 Fleetyards。請再試一次。"
          }
        },
        "guilded": "Guilded 伺服器",
        "homepage": "首頁",
        "twitch": "Twitch 頻道",
        "youtube": "Youtube 頻道",
        "backgroundImage": "背景圖片",
        "ts": "Teamspeak 伺服器",
        "awaitingConfirmation": "等待艦隊確認",
        "members": {
          "verifiedOrgMember": "%{sid} 的已驗證成員",
          "verifiedOrgMemberChecked": "%{sid} 的已驗證成員，檢查於 %{checked}",
          "primary": "主艦隊?",
          "shipsFilter": {
            "label": "哪些飛船應該新增到艦隊?",
            "nullablePrompt": "未選擇選項",
            "field": "飛船選擇",
            "values": {
              "all": "所有飛船",
              "hangar_group": "指定機庫群組中的所有飛船",
              "hide": "無飛船"
            }
          },
          "hangarGroupId": {
            "field": "機庫群組",
            "label": "指定機庫群組",
            "nullablePrompt": "未選擇群組"
          },
          "blueprintsFilter": {
            "label": "哪些藍圖應與艦隊共享？",
            "nullablePrompt": "未選擇任何選項",
            "field": "藍圖選擇",
            "values": {
              "all": "我擁有的全部藍圖",
              "hide": "不共享藍圖"
            }
          },
          "total": "總計: %{count}",
          "rsiTotal": "RSI 上: %{count}",
          "joined": "加入於",
          "invited": "已邀請",
          "invitedAt": "邀請/請求於",
          "requested": "已請求加入",
          "declined": "已拒絕",
          "pending": "待處理的邀請與請求",
          "accepted": "成員",
          "role": "角色",
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord",
          "views": {
            "members": "成員",
            "invites": "邀請"
          },
          "health": {
            "overview": "檢查項目",
            "summary": {
              "attention": {
                "one": "%{total} 項檢查中有 %{count} 項需要處理",
                "other": "%{total} 項檢查中有 %{count} 項需要處理"
              },
              "clear": "全部 %{total} 項檢查均正常"
            },
            "groups": {
              "leadership": "領導層",
              "rsi": "RSI 組織",
              "activity": "活躍度",
              "requests": "申請與邀請",
              "integrations": "整合"
            },
            "days": {
              "one": "%{count} 天",
              "other": "%{count} 天"
            },
            "checks": {
              "admins": {
                "title": "管理員",
                "overview": "管理員",
                "clear": "%{admins} 名成員擔任管理員。"
              },
              "unverified": {
                "title": "未通過 %{sid} 驗證",
                "overview": "未驗證",
                "description": "當成員自己的 RSI 組織列表包含 %{sid} 時即視為已驗證。每一列說明了無法確認的原因。",
                "clear": "所有成員都已通過 %{sid} 驗證。"
              },
              "noHandle": {
                "title": "沒有 RSI 帳號名",
                "overview": "沒有 RSI 帳號名",
                "clear": "所有成員都填寫了 RSI 帳號名。"
              },
              "inactive": {
                "title": "不活躍成員",
                "overview": "%{count}+ 天不活躍",
                "clear": "所有人在過去 %{count} 天內都有活動。"
              },
              "joinRequests": {
                "title": "等待超過一週的入隊申請",
                "overview": "舊入隊申請",
                "clear": "沒有入隊申請等待超過一週。"
              },
              "invitations": {
                "title": "無人回應的邀請",
                "overview": "未回應的邀請",
                "clear": "沒有邀請超過兩週未處理。"
              },
              "inviteUrls": {
                "title": "需要整理的邀請連結",
                "overview": "邀請連結",
                "clear": "所有邀請連結都在使用中。"
              },
              "discord": {
                "title": "未連結 Discord",
                "overview": "Discord",
                "clear": "所有成員都已連結 Discord。"
              },
              "emptySquadrons": {
                "title": "無人加入的中隊",
                "overview": "空中隊",
                "clear": "每個中隊都有成員。"
              },
              "noSquadron": {
                "title": "未加入中隊的成員",
                "overview": "無中隊",
                "clear": "所有成員都在中隊中。"
              },
              "hiddenShips": {
                "title": "未納入艦隊的艦船",
                "overview": "隱藏的機庫",
                "clear": "所有成員都與艦隊共享其艦船。"
              }
            },
            "facts": {
              "joined": "於 %{date} 加入",
              "lastActive": "最後活動於%{distance}",
              "neverActive": "從未活動",
              "checked": "檢查於%{distance}",
              "requested": "申請於%{distance}",
              "invited": "邀請於%{distance}",
              "invitedBy": "由 %{name} 邀請",
              "noDiscord": "未連結 Discord 帳號",
              "noSquadron": "無中隊",
              "noHandle": "未填寫帳號名",
              "linkExpired": "已於%{distance}到期",
              "linkUsedUp": "無剩餘次數",
              "createdBy": "由 %{name} 建立",
              "used": {
                "one": "已使用 1 次",
                "other": "已使用 %{count} 次"
              },
              "team": "小組",
              "created": "建立於 %{date}",
              "linkUnused": "從未使用，建立於%{distance}"
            },
            "gaps": {
              "no_handle": "個人檔案中沒有 RSI 帳號名",
              "handle_unverified": "RSI 帳號名未驗證",
              "orgs_not_checked": "尚未讀取組織列表",
              "org_not_listed": "其組織列表中沒有 %{sid}"
            },
            "orgStats": {
              "rsi": "%{sid} 在 RSI 上",
              "roster": "在 FleetYards 上",
              "gap": "從未在此加入"
            },
            "fleetNotVerified": "%{sid} 本身尚未驗證，因此其他地方不會將任何成員顯示為已驗證。",
            "singleAdmin": "如果 %{name} 離開或失去存取權限，將沒有人能在 FleetYards 上管理 %{fleet}。",
            "hiddenShips": {
              "one": "%{count} 名成員未將機庫納入艦隊艦船列表。",
              "other": "%{count} 名成員未將機庫納入艦隊艦船列表。"
            },
            "deleteLinkFailed": "無法刪除該邀請連結。",
            "noAdmin": "沒有人擔任管理員，因此沒有人能在 FleetYards 上管理 %{fleet}。",
            "adminCandidates": "晉升為管理員",
            "addedToSquadron": {
              "success": "已加入中隊。",
              "failure": "無法加入中隊。"
            },
            "reminded": {
              "success": "提醒已傳送。",
              "failure": "無法傳送提醒。"
            },
            "remindedAt": "已於%{distance}提醒。一週後可再次提醒。"
          },
          "card": {
            "verified": "已驗證",
            "unverified": "未驗證",
            "squadrons": "中隊"
          }
        },
        "squadrons": {
          "index": "中隊",
          "name": "名稱",
          "shortDescription": "簡短描述",
          "shortDescriptionHint": "一兩行，顯示在卡片上",
          "description": "描述",
          "descriptionHint": "中隊頁面上的完整文字",
          "noDescription": "尚未新增描述。",
          "icon": "圖示",
          "iconHint": "正方形圖片，以圓形顯示",
          "team": "小隊",
          "teamHint": "小隊對所有人開放；否則成員只能屬於一個中隊",
          "restrictedToHint": "只有這些中隊可見",
          "discordChannel": "Discord 頻道",
          "discordChannelHint": "僅限此中隊的活動會在這裡公告，不會出現在 Discord 的其他地方。未設定頻道時不會在 Discord 上公告。",
          "notAnnounced": "%{names} 未設定 Discord 頻道，不會在 Discord 上公告。",
          "blockedBy": "已在 %{squadron} 中隊中",
          "color": "顏色",
          "colorSuggestions": "取自圖示：",
          "memberCount": "%{count} 位成員",
          "members": "成員",
          "joinedAt": "加入中隊時間",
          "searchMembers": "搜尋成員",
          "availableMembers": "可新增的成員",
          "selectedMembers": "已選擇 %{count} 位",
          "rank": "職級",
          "ranksHint": "本艦隊所有中隊使用的名稱。重新命名職級不會改變其位置和權限。",
          "rankName": "名稱",
          "defaultRank": "預設",
          "defaultRankToggle": "新成員以此職級開始",
          "rankRights": {
            "singleHolder": "每個中隊一名",
            "managesMembers": "可新增和移除職級低於自己的成員",
            "managesRanks": "可設定低於自己的職級"
          },
          "views": {
            "members": "成員",
            "requests": "申請"
          },
          "requestedAt": "申請時間",
          "requests": "申請"
        },
        "roles": {
          "permanent": "永久",
          "default": "預設",
          "defaultToggle": "新成員獲得此角色",
          "privilegeGroups": {
            "fleet": "艦隊",
            "memberships": "成員",
            "squadrons": "中隊",
            "invites": "邀請",
            "vehicles": "載具",
            "blueprints": "藍圖",
            "roles": "角色",
            "inventories": "庫存",
            "missions": "任務",
            "events": "活動",
            "allies": "盟友",
            "contracts": "合約",
            "payouts": "分帳",
            "notifications": "通知",
            "announcements": "公告"
          },
          "privileges": {
            "fleet:update": "更新艦隊",
            "fleet:update:images": "更新圖片",
            "fleet:update:description": "更新描述",
            "fleet:delete": "刪除艦隊",
            "fleet:manage": "管理艦隊",
            "fleet:memberships:read": "檢視成員",
            "fleet:memberships:create": "邀請成員",
            "fleet:memberships:update": "更新成員",
            "fleet:memberships:delete": "移除成員",
            "fleet:memberships:manage": "管理成員",
            "fleet:squadrons:read": "檢視中隊",
            "fleet:squadrons:create": "建立中隊",
            "fleet:squadrons:update": "編輯中隊",
            "fleet:squadrons:delete": "刪除中隊",
            "fleet:squadrons:members:manage": "管理中隊成員",
            "fleet:squadrons:manage": "管理中隊",
            "fleet:invites:read": "檢視邀請",
            "fleet:invites:create": "建立邀請",
            "fleet:invites:update": "更新邀請",
            "fleet:invites:delete": "刪除邀請",
            "fleet:invites:manage": "管理邀請",
            "fleet:vehicles:read": "檢視載具",
            "fleet:vehicles:create": "新增載具",
            "fleet:vehicles:update": "更新載具",
            "fleet:vehicles:delete": "移除載具",
            "fleet:vehicles:manage": "管理載具",
            "fleet:blueprints:read": "查看藍圖",
            "fleet:roles:read": "檢視角色",
            "fleet:roles:create": "建立角色",
            "fleet:roles:update": "更新角色",
            "fleet:roles:delete": "刪除角色",
            "fleet:roles:manage": "管理角色",
            "fleet:inventories:read": "檢視庫存",
            "fleet:inventories:create": "建立庫存",
            "fleet:inventories:update": "更新庫存",
            "fleet:inventories:delete": "刪除庫存",
            "fleet:inventories:manage": "管理庫存",
            "fleet:missions:read": "檢視任務",
            "fleet:missions:create": "建立任務",
            "fleet:missions:update": "更新任務",
            "fleet:missions:delete": "刪除任務",
            "fleet:missions:manage": "管理任務",
            "fleet:events:read": "檢視活動",
            "fleet:events:create": "建立活動",
            "fleet:events:update": "更新活動",
            "fleet:events:delete": "刪除活動",
            "fleet:events:manage": "管理活動",
            "fleet:allies:read": "檢視盟友",
            "fleet:allies:create": "新增盟友",
            "fleet:allies:delete": "移除盟友",
            "fleet:allies:manage": "管理盟友",
            "fleet:contracts:read": "檢視合約",
            "fleet:contracts:create": "建立合約",
            "fleet:contracts:update": "更新合約",
            "fleet:contracts:delete": "刪除合約",
            "fleet:contracts:manage": "管理合約",
            "fleet:payouts:read": "檢視分帳",
            "fleet:payouts:create": "記錄分帳",
            "fleet:payouts:update": "更新分帳",
            "fleet:payouts:delete": "刪除分帳",
            "fleet:payouts:manage": "管理分帳",
            "fleet:notifications:manage": "管理通知設定",
            "fleet:announcements:manage": "管理公告"
          },
          "name": "名稱",
          "rank": "階級"
        },
        "inviteUrls": {
          "noExpiration": "Never expires",
          "used": "已使用 %{count} 次",
          "usedOfLimit": "已使用 %{count} / %{limit}",
          "expiresIn": "Expires in %{time}",
          "expired": "Expired",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 天",
            "7_days": "7 days"
          },
          "limitOptions": {
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses",
            "infinite": "No limit"
          }
        },
        "calendarSubscription": {
          "intro": "產生一個私人連結，讓成員可以在自己的行事曆應用程式（Apple Calendar、Google Calendar、Outlook）中訂閱這個艦隊的活動。",
          "howTo": "把上面的連結分享給你的成員。他們只要把它貼進行事曆應用程式（\"訂閱行事曆\"或\"以網址新增\"）即可。這個連結是私人的 — 任何拿到連結的人都能看到這個艦隊的活動。"
        },
        "notifications": {
          "inAppHint": "選擇哪些活動狀態變化要以應用程式內通知的形式顯示給艦隊成員。",
          "events": {
            "fleet_event": {
              "published": "活動已發布",
              "locked": "報名已鎖定",
              "unlocked": "報名已重新開放",
              "starting_soon": "活動即將開始",
              "started": "活動已開始",
              "completed": "活動已完成",
              "cancelled": "活動已取消",
              "archived": "活動已封存",
              "destroyed": "活動已刪除"
            },
            "fleet_event_signup": {
              "created": "新增報名",
              "withdrawn": "報名已取消"
            }
          }
        },
        "inventories": {
          "name": "名稱",
          "description": "描述",
          "location": "位置",
          "visibility": "可見範圍",
          "manager": "管理人",
          "itemsCount": "記錄數",
          "visibilities": {
            "members_only": "僅限成員",
            "officers_only": "僅限軍官",
            "squadron_only": "僅中隊"
          }
        },
        "allies": "盟友可見艦船",
        "alliesStats": "盟友可見統計",
        "alliesMembers": "盟友可見成員列表",
        "squadronsEnabled": "使用中隊",
        "listed": "在艦隊目錄中顯示",
        "listedInfo": "已驗證、公開且至少有兩名成員的艦隊會出現在艦隊目錄中。私人艦隊永遠不會被列出。",
        "alignment": "陣營",
        "alignments": {
          "lawful": "守法",
          "neutral": "中立",
          "outlaw": "非法"
        },
        "activities": {
          "bounty_hunting": "賞金獵人",
          "engineering": "工程",
          "exploration": "探索",
          "freelancing": "自由職業",
          "infiltration": "滲透",
          "medical": "醫療",
          "piracy": "海盜",
          "resources": "資源",
          "scouting": "偵察",
          "security": "保安",
          "smuggling": "走私",
          "social": "社交",
          "trading": "貿易",
          "transport": "運輸"
        },
        "commitments": {
          "casual": "休閒",
          "regular": "一般",
          "hardcore": "硬核"
        },
        "rsiProfile": {
          "info": "每天從你的組織的 RSI 頁面同步一次。請在 RSI 上修改這些資訊。",
          "primaryActivity": "主要活動",
          "secondaryActivity": "次要活動",
          "language": "語言",
          "commitment": "投入程度",
          "recruiting": "招募中",
          "roleplay": "角色扮演"
        },
        "contractCovers": {
          "transport": "運送封面圖",
          "procurement": "採購封面圖",
          "crafting": "製造封面圖"
        }
      },
      "hangarGroup": {
        "name": "名稱",
        "color": "顏色",
        "sort": "排序",
        "public": "在公開機庫顯示?"
      },
      "source": "來源",
      "loadout": {
        "marker": "配置「%{name}」",
        "fleetyards": "Fleetyards 配裝",
        "namePlaceholder": "配置名稱...",
        "urlPlaceholder": "貼上 erkul.games 或 spviewer.eu 的配置網址...",
        "activateHint": "點擊將其設為目前配置",
        "activeHint": "這是目前配置",
        "kinds": {
          "fleetyards": "Fleetyards",
          "erkul": "Erkul",
          "spviewer": "SPViewer",
          "link": "連結"
        },
        "public": "公開",
        "private": "私密",
        "empty": "尚無配置。建立一個開始使用。",
        "active": "使用中",
        "activate": "設為使用中"
      },
      "model": {
        "hidden": "隱藏?",
        "active": "活躍?",
        "inGame": "已實裝?",
        "adiMap": "ADI 地圖?",
        "ground": "地面載具?",
        "productionNote": "生產備註",
        "rsiId": "RSI ID",
        "length": "長度",
        "beam": "寬度",
        "height": "高度",
        "scKey": "SC Key",
        "price": "價格",
        "pledgePrice": "質押價格",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "質量",
        "crew": "船員",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "最大速度",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "貨物",
        "cargoHolds": "貨艙",
        "keepCargo": "保留此貨運數值，而不是使用遊戲檔案中的貨艙",
        "hydrogenFuelTankSize": "氫燃料箱大小",
        "hydrogenFuelTanks": "氫燃料箱",
        "quantumFuelTankSize": "量子燃料箱大小",
        "quantumFuelTanks": "量子燃料箱",
        "externalFuelTanks": "外掛燃料箱",
        "orePods": "礦石艙",
        "weaponRacks": "武器架",
        "medicalBedsTier": "%{tier} 級醫療床",
        "medicalBedsNamed": "%{name}醫療床",
        "respawnBeds": "重生床位",
        "salvageStorage": "回收儲存",
        "externalFuelTanksTotal": "總容量",
        "externalFuelTanksCount": "燃料艙",
        "refuelBoom": "加油臂",
        "refuelBoomArm": "支臂",
        "refuelBoomNozzle": "噴嘴",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "偏航（增強）",
        "pitchBoosted": "俯仰（增強）",
        "rollBoosted": "翻滾（增強）",
        "variants": "變體",
        "manufacturer": "製造商",
        "loaners": "借用船",
        "paints": "塗裝",
        "modules": "模組",
        "modulePackages": "模組套件",
        "upgrades": "升級套件",
        "brochure": "手冊",
        "holo": "Holo",
        "angledView": "斜視圖",
        "angledViewColored": "斜視圖（彩色）",
        "portView": "左舷視圖",
        "portViewColored": "左舷視圖（彩色）",
        "frontView": "前視圖",
        "frontViewColored": "前視圖（彩色）",
        "topView": "俯視圖",
        "topViewColored": "俯視圖（彩色）",
        "onSale": "販售中",
        "playerOwnable": "玩家可擁有?",
        "ingameOnly": "僅遊戲內取得",
        "canLandOnPlanets": "可在行星降落",
        "cannotLandOnPlanets": "無法在行星降落",
        "salesPage": "銷售頁面",
        "addons": "模組與升級套件",
        "storeImage": "商店圖片",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "船員職位",
        "needsCuration": "需要人工校訂",
        "curatedPosition": "手動校訂的位置",
        "baseModel": "基礎型號",
        "fleetchartOffsetLength": "艦隊圖表長度偏移",
        "fleetchartOffsetBeam": "艦隊圖表寬度偏移",
        "extendedLength": "展開長度",
        "extendedBeam": "展開寬度",
        "extendedHeight": "展開高度",
        "extendedFleetchartOffsetLength": "展開艦隊圖表長度偏移",
        "extendedFleetchartOffsetBeam": "展開艦隊圖表寬度偏移",
        "defaultHolo": "預設 Holo",
        "extendedHolo": "展開 Holo",
        "extendedTopView": "展開俯視圖",
        "extendedTopViewColored": "展開俯視圖（彩色）",
        "extendedPortView": "展開左舷視圖",
        "extendedPortViewColored": "展開左舷視圖（彩色）",
        "extendedFrontView": "展開前視圖",
        "extendedFrontViewColored": "展開前視圖（彩色）",
        "extendedAngledView": "展開斜視圖",
        "extendedAngledViewColored": "展開斜視圖（彩色）",
        "landedHolo": "著陸 Holo",
        "landedTopView": "著陸俯視圖",
        "landedPortView": "著陸左舷視圖",
        "landedFrontView": "著陸前視圖",
        "landedAngledView": "著陸斜視圖",
        "landedTopViewColored": "著陸俯視圖（彩色）",
        "landedPortViewColored": "著陸左舷視圖（彩色）",
        "landedFrontViewColored": "著陸前視圖（彩色）",
        "landedAngledViewColored": "著陸斜視圖（彩色）",
        "angledRearView": "後斜視圖",
        "angledRearViewColored": "後斜視圖（彩色）",
        "bottomView": "仰視圖",
        "bottomViewColored": "仰視圖（彩色）",
        "rearView": "後視圖",
        "rearViewColored": "後視圖（彩色）",
        "starboardView": "右舷視圖",
        "starboardViewColored": "右舷視圖（彩色）",
        "extendedAngledRearView": "展開後斜視圖",
        "extendedAngledRearViewColored": "展開後斜視圖（彩色）",
        "extendedBottomView": "展開仰視圖",
        "extendedBottomViewColored": "展開仰視圖（彩色）",
        "extendedRearView": "展開後視圖",
        "extendedRearViewColored": "展開後視圖（彩色）",
        "extendedStarboardView": "展開右舷視圖",
        "extendedStarboardViewColored": "展開右舷視圖（彩色）",
        "landedAngledRearView": "著陸後斜視圖",
        "landedAngledRearViewColored": "著陸後斜視圖（彩色）",
        "landedBottomView": "著陸仰視圖",
        "landedBottomViewColored": "著陸仰視圖（彩色）",
        "landedRearView": "著陸後視圖",
        "landedRearViewColored": "著陸後視圖（彩色）",
        "landedStarboardView": "著陸右舷視圖",
        "landedStarboardViewColored": "著陸右舷視圖（彩色）",
        "holoLite": "輕量 Holo",
        "extendedHoloLite": "展開輕量 Holo",
        "landedHoloLite": "著陸輕量 Holo",
        "holoTextured": "材質 Holo",
        "state": {
          "flight": "飛行中",
          "extended": "展開",
          "landed": "著陸"
        },
        "productionStatus": {
          "in-production": "生產中",
          "in-concept": "概念階段",
          "ready": "機庫就緒",
          "flight-ready": "可飛行",
          "announced": "已公佈"
        },
        "carriedBy": "可被搭載於",
        "landedLength": "著陸長度",
        "landedBeam": "著陸寬度",
        "landedHeight": "著陸高度",
        "landedFleetchartOffsetLength": "著陸艦隊圖長度偏移",
        "landedFleetchartOffsetBeam": "著陸艦隊圖寬度偏移",
        "owners": {
          "title": "你的圈子",
          "yourShips": "你的艦船",
          "friends": "好友",
          "fleets": "你的艦隊",
          "more": "另外 %{count} 個",
          "empty": "你認識的人還沒有擁有這艘艦船。",
          "fleetShips": {
            "one": "%{count} 艘艦船",
            "other": "%{count} 艘艦船"
          }
        }
      },
      "models": {
        "extraColumns": "欄",
        "table": {
          "columns": {
            "storeImage": "圖片",
            "storeImageWide": "寬圖片",
            "rsiStoreImage": "RSI 圖片",
            "rsiStoreImageWide": "寬 RSI 圖片",
            "angledView": "3D 圖片",
            "angledViewWide": "寬 3D 圖片",
            "rsiId": "RSI ID",
            "hidden": "隱藏",
            "active": "活躍",
            "createdAt": "建立於",
            "updatedAt": "更新於",
            "manufacturerName": "製造商",
            "length": "長度",
            "beam": "寬度",
            "height": "高度",
            "mass": "質量",
            "cargo": "貨物",
            "quantumFuelTankSize": "量子燃料",
            "hydrogenFuelTankSize": "氫燃料",
            "crew": "船員",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "最大速度",
            "groundMaxSpeed": "地面速度",
            "focus": "定位",
            "productionStatus": "生產狀態",
            "price": "價格",
            "pledgePrice": "質押價格"
          }
        }
      },
      "metrics": {
        "info": "資訊",
        "levels": "等級",
        "views": "檢視",
        "base": "基礎",
        "crew": "船員",
        "speed": "速度",
        "cargo": "貨物",
        "combat": "戰鬥",
        "hardpoints": "掛載點"
      },
      "flight": {
        "boostCapacitor": "加力電容",
        "boostCapacity": "容量",
        "boostRegen": "恢復",
        "boostRegenDelay": "恢復延遲",
        "boostRamp": "升 / 降時間",
        "title": "飛行",
        "scm": "戰鬥巡航",
        "nav": "巡航",
        "boost": "加速",
        "boostSub": "後燃器",
        "reverse": "倒車",
        "maneuverability": "機動性",
        "fuel": "燃料",
        "fuelHydrogen": "氫",
        "fuelQuantum": "量子",
        "fuelFullMain": "全推力，主推進器",
        "fuelFullAll": "全推力，所有推進器",
        "durationHoursMinutes": "%{hours} 小時 %{minutes} 分鐘",
        "durationMinutes": "%{minutes} 分鐘",
        "hint": "加速後的操控性會隨引擎的電力格提升；引擎沒有供電時全部為零。"
      },
      "base": {
        "price": "價格",
        "priceInGame": "遊戲內",
        "pricePledge": "質押",
        "availability": "供應狀況"
      },
      "availability": {
        "title": "供應狀況",
        "buy": "買入",
        "rent": "租借",
        "sell": "賣出",
        "cheapest": {
          "buy": "最便宜的購買地點",
          "rent": "最便宜的租借地點"
        },
        "bestSale": "最高收購價",
        "allLocations": "全部地點",
        "locations": {
          "one": "%{count} 個地點",
          "other": "%{count} 個地點"
        },
        "empty": "沒有已知的購買或租借地點。",
        "timeRange": {
          "1-day": "1 天",
          "3-days": "3 天",
          "7-days": "7 天",
          "30-days": "30 天"
        }
      },
      "cargo": {
        "title": "貨物",
        "holdsSub": "分佈於 %{count} 個貨艙",
        "maxContainerSub": "可容納的最大貨櫃",
        "containers": "貨櫃容量",
        "hint": "各種尺寸的貨櫃在貨物網格上最多可放置的數量；長條顯示它佔總容量的比例。"
      },
      "weaponRacks": {
        "slots": "槽位",
        "racks": "武器架",
        "categories": {
          "weapon": "武器",
          "gadget": "小工具",
          "cargo": "貨物",
          "carriable": "可攜帶物品",
          "armor": "護甲",
          "other": "其他"
        },
        "size": "S%{size}",
        "sizeRange": "S%{min}–S%{max}",
        "sizeUpTo": "最高 S%{size}",
        "only": "僅限%{tag}",
        "tags": {
          "multitool": "多功能工具",
          "medical_injection": "醫療筆",
          "grenade": "手榴彈"
        },
        "hint": "船上所有武器架的槽位，依可放置物品與尺寸分組。"
      },
      "storageContainers": {
        "total": "總容量",
        "count": "容器",
        "perContainer": "每個",
        "hintOre": "存放開採的礦石，不是貨物。",
        "hintSalvage": "存放回收的材料，不是貨物。"
      },
      "fuelTanks": {
        "capacitySub": "分佈於 %{count} 個燃料艙",
        "podsSub": "外部掛點",
        "components": "燃料艙類型",
        "perPod": "每個燃料艙",
        "hint": "掛在外部掛載點的燃料艙所攜帶的燃料；長條顯示每種類型佔總容量的比例。"
      },
      "refuelBoom": {
        "fuelFlowSub": "氫燃料輸送",
        "quantumFlowSub": "量子燃料輸送",
        "captureRadiusSub": "對接容許範圍",
        "equipment": "裝備",
        "hint": "加油臂的輸送速率，以及噴嘴的對接容許範圍。"
      },
      "combat": {
        "title": "戰鬥",
        "openPenetrationCheck": "穿透檢測",
        "dps": "爆發 DPS",
        "dpsSub": "%{count} 件武器",
        "sustained": "持續 DPS",
        "sustainedSub": "計入能量回復與熱量",
        "alpha": "Alpha",
        "alphaSub": "每次齊射",
        "weapons": "武器",
        "missileDamage": "飛彈傷害",
        "armedMissiles": "可武裝飛彈",
        "armedMissilesSub": "發射間隔 %{cooldown} 秒",
        "composition": "傷害組成",
        "damagePhysical": "物理",
        "damageEnergy": "能量",
        "damageDistortion": "扭曲",
        "damageThermal": "熱能",
        "controlComposition": "依操控分類的DPS",
        "controlGroups": {
          "pilot": "駕駛員",
          "manned": "有人砲塔",
          "remote": "遙控砲塔",
          "pds": "點防禦"
        },
        "hint": "以預設配置計算的 DPS。持續值會計入每件武器的能量池回復與過熱循環。不含飛彈。"
      },
      "power": {
        "title": "能量分配",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "重設",
        "auto": "自動",
        "aimAssist": "瞄準輔助",
        "cooling": "冷卻",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "點擊以切換軸向（x / y / z）",
        "segmentsUsed": "%{used} / %{total} 段",
        "hint": "在各系統之間分配能量。武器的持續 DPS 會隨分配到的能量提升；其餘部分會自動平衡。",
        "families": {
          "weapon": "武器",
          "shield": "護盾",
          "engine": "引擎",
          "radar": "雷達",
          "coolers": "冷卻器",
          "qdrive": "量子引擎",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "維生系統",
          "miningLaser": "採礦雷射",
          "salvage": "打撈",
          "tractorBeam": "牽引光束",
          "towingbeam": "拖曳光束"
        }
      },
      "defense": {
        "title": "防禦",
        "shieldHp": "護盾 HP",
        "shieldHpSub": "%{count} 具產生器",
        "shieldRegen": "回復",
        "shieldResistances": "抗性",
        "shieldAbsorption": "吸收",
        "shieldFaces": "護盾面",
        "armor": "裝甲",
        "deflection": "偏轉",
        "armorReduction": "傷害減免",
        "armorSelfResistance": "自身抗性",
        "armorSignature": "訊號特徵",
        "countermeasures": "干擾措施",
        "countermeasureDuration": "持續時間",
        "countermeasure": {
          "decoy": "誘餌彈",
          "noise": "干擾箔"
        },
        "damageType": {
          "physical": "物理",
          "energy": "能量",
          "distortion": "扭曲",
          "thermal": "熱能"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "hint": "以預設配置計算的護盾、裝甲與干擾措施數值。吸收率低於 100% 表示該傷害類型在護盾還撐著的時候就會打到船體。",
        "openDeflectionCheck": "偏轉檢測"
      },
      "penetrationCheck": {
        "title": "穿透檢測",
        "intro": "— 它的武器能擊穿哪些艦船？",
        "noWeapons": "此配裝沒有可檢測單發傷害的機砲。",
        "weapons": "武器",
        "shieldHealth": "目標護盾狀態",
        "armorHealth": "目標裝甲狀態",
        "ship": "艦船",
        "hoverHint": "將滑鼠停在艦船上查看各武器明細。",
        "note": "每門選取的機砲都依照與偏轉檢測相同的規則，與每艘艦船的護盾和裝甲偏轉進行比較；只要其中任一門能夠擊穿，該艦船即視為被擊穿，並依最接近閾值的機砲排序。沒有裝甲的艦船不在列表中，因為沒有可跨越的閾值。",
        "sortBy": "排序方式",
        "sort": {
          "margin": "差值",
          "ttk": "擊毀時間"
        },
        "ttk": "TTK",
        "effectiveHp": "有效生命值",
        "shieldsDown": "護盾擊破",
        "ttkNote": "擊毀時間使用所選機砲在目前能量分配下的持續每秒傷害，並從上方設定的護盾和裝甲健康度開始計算。護盾承受其吸收的傷害（扣除抗性），其餘傷害傳給裝甲；裝甲承受傷害直至損毀，之後傷害傳給船體。畸變傷害只會消耗護盾。只有當所有機砲的停火時間都超過護盾的再生延遲時，護盾才會再生；護盾一旦被擊破便不再恢復。有效生命值是摧毀艦船所需的單一類型原始傷害，不計偏轉。標有 TTK 的光束武器只計入擊毀時間：裝甲永遠不會偏轉它們，且由於沒有單發傷害，它們不參與差值計算。飛彈不計入。"
      },
      "deflectionCheck": {
        "title": "偏轉檢測",
        "intro": "— 哪些武器能貫穿它的防禦？",
        "noArmor": "這艘飛船沒有裝甲，因此不會偏轉任何攻擊。",
        "allSizes": "全部",
        "deflected": "被偏轉",
        "pierce": "貫穿",
        "weapon": "武器",
        "boundary": "偏轉門檻",
        "alpha": "Alpha",
        "threshold": "已跨過門檻",
        "absorbed": "被吸收",
        "versus": "vs",
        "hoverHint": "把滑鼠移到武器上可查看各傷害類型的細項。",
        "note": "Alpha 以每顆彈丸為單位、在護盾吸收之後比較 — 只要在任一種傷害類型上勝過偏轉值，該武器就能貫穿。護盾完全吸收的傷害類型永遠到不了裝甲，因此列為被吸收而非被偏轉：擋下它的是護盾，不是船體。護盾吸收率會依護盾血量在公布的最小至最大範圍之間內插，裝甲偏轉值則隨裝甲血量線性變化。雷射光束不列入計算 — 它造成的是持續傷害，沒有可供比較的單發 Alpha。",
        "margin": "差額",
        "reachesArmor": "打到裝甲",
        "stoppedByShields": "護盾吸收",
        "verdict": {
          "absorbed": "已吸收",
          "deflected": "已偏轉",
          "pierces": "已貫穿"
        },
        "shieldHealth": "護盾血量",
        "armorHealth": "裝甲血量",
        "absorb": "吸收",
        "defl": "偏轉",
        "type": "類型",
        "size": "尺寸"
      },
      "hull": {
        "category": {
          "vital": "要害",
          "secondary": "次要",
          "breakable": "可破壞",
          "subpart": "子部件",
          "cosmetic": "外觀"
        },
        "composition": "船體組成",
        "door": "門",
        "doors": "門",
        "doorsNote": "可破壞的內部艙門屬於獨立區域 — 它們有自己的血量，不計入船體 HP。",
        "doorsSub": "%{count} 個可破壞",
        "hint": "船體 HP 是所有部件血量的總和。",
        "hullHp": "船體 HP",
        "hullHpSub": "所有部件的總和",
        "integrity": "船體完整度",
        "noHp": "無 HP",
        "parts": "船體部件",
        "partsNote": "部件依血量排序；外觀部件（門、梯子、擋板）本身沒有血量。遊戲檔案沒有提供父子關係，因此這是一份平面清單，而不是結構樹。",
        "partsSub": "分佈於 %{count} 個類別",
        "partsTree": "部件 · damageMax",
        "showParts": "顯示船體部件",
        "title": "船體",
        "totalHp": "船體總 HP"
      },
      "manufacturer": {
        "shortName": "簡稱",
        "shipyard": "船塢",
        "longName": "全名",
        "code": "代碼",
        "logo": "標誌",
        "logoOverridden": "標誌（已覆寫）",
        "icon": "圖示（遊戲檔案）",
        "iconOverridden": "圖示（已覆寫）",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "標題",
        "body": "內文",
        "discordParts": "Discord 訊息",
        "socialParts": "社群貼文",
        "link": "連結",
        "notifyUsers": "應用內通知",
        "postDiscord": "Discord 更新頻道",
        "postBluesky": "Bluesky",
        "schedule": "定時發送",
        "publishAt": "發送時間"
      },
      "fundingGoal": {
        "title": "標題",
        "description": "描述",
        "amount": "金額",
        "currency": "幣別",
        "effectiveFrom": "生效日",
        "endedAt": "結束於"
      },
      "supporterContribution": {
        "name": "支持者名稱",
        "user": "已連結帳戶",
        "amount": "金額",
        "currency": "幣別",
        "anonymous": "匿名",
        "recurring": "定期",
        "startedAt": "開始於",
        "endedAt": "結束於",
        "payerEmail": "付款人電子郵件",
        "claimKey": "支持者權杖",
        "linkedVia": "連結方式",
        "source": "來源",
        "note": "內部備註",
        "stats": {
          "total": "總計",
          "count": "捐助筆數",
          "currentMonth": "本月",
          "currentMonthCount": "%{count} 筆捐助",
          "recurringCount": "定期",
          "anonymousCount": "匿名"
        },
        "chart": {
          "contributions": "捐助",
          "goal": "目標"
        }
      },
      "itemPrice": {
        "price": "價格",
        "location": "位置",
        "locationUrl": "位置 URL"
      },
      "video": {
        "url": "URL",
        "videoType": "類型"
      },
      "modelModule": {
        "slot": "槽位",
        "noSlot": "無槽位",
        "slotsOnHull": "此艦船的模組槽位：%{slots}",
        "noSlotsOnHull": "遊戲檔案沒有為此艦船提供模組槽位；可以設定任意名稱",
        "name": "名稱",
        "description": "描述",
        "price": "價格",
        "pledgePrice": "承諾價格",
        "productionStatus": "生產狀態",
        "scKey": "SC Key",
        "cargo": "貨物",
        "storeImage": "商店圖片",
        "active": "啟用？",
        "hidden": "隱藏？"
      },
      "dockAddition": {
        "model": "飛船",
        "hint": "該泊位可容納但其類別未涵蓋的飛船。",
        "empty": "已指定的飛船"
      },
      "dockCapacity": {
        "ladder": "等級序列",
        "size": "類別",
        "quantity": "數量",
        "display": "作為標籤顯示",
        "hint": "該泊位的用途。各條目為互選方案，而非累加。",
        "empty": "容量條目"
      },
      "dockCapacityLadders": {
        "ship": "飛船",
        "vehicle": "車輛"
      },
      "vehicleSizes": {
        "extra_extra_small": "超超小型 (XXS)",
        "extra_small": "超小型 (XS)",
        "small": "小型 (S)",
        "medium": "中型 (M)",
        "large": "大型 (L)",
        "extra_large": "超大型 (XL)",
        "extra_extra_large": "超超大型 (XXL)"
      },
      "dock": {
        "name": "名稱",
        "dockType": "停靠類型",
        "shipSize": "飛船尺寸",
        "access": "進入方式",
        "length": "長度",
        "beam": "寬度",
        "height": "高度",
        "unmeasured": "未測量"
      },
      "modelPosition": {
        "name": "名稱",
        "positionType": "職位類型",
        "source": "來源",
        "position": "排序",
        "types": {
          "pilot": "駕駛",
          "copilot": "副駕駛",
          "turret_gunner": "砲塔射手",
          "engineer": "工程師",
          "gunner": "射手",
          "loadmaster": "裝載長",
          "passenger": "乘客",
          "operator": "操作員",
          "custom": "自訂"
        }
      },
      "modelUpgrade": {
        "name": "名稱",
        "description": "描述",
        "pledgePrice": "質押價格",
        "active": "活躍?",
        "hidden": "隱藏?"
      },
      "modelModulePackage": {
        "name": "名稱",
        "description": "描述",
        "pledgePrice": "質押價格",
        "modules": "模組",
        "active": "活躍?",
        "hidden": "隱藏?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "旋轉 (°)"
      },
      "modelLoaner": {
        "hidden": "隱藏?",
        "loanerModel": "借用型號"
      },
      "modelSnubCraft": {
        "snubCraft": "Snub Craft"
      },
      "modelPaint": {
        "hidden": "隱藏?",
        "active": "活躍?",
        "onSale": "販售中",
        "pledgePrice": "質押價格",
        "productionStatus": "生產狀態",
        "productionNote": "生產備註",
        "copyHint": "選擇要把這個塗裝複製過去的目標飛船。複製過程不會修改塗裝資料。",
        "bulkCopyHint": "選擇要把這 %{count} 個塗裝複製過去的目標飛船。複製過程不會修改塗裝資料。",
        "copySameModel": "目標飛船必須與來源飛船不同。"
      },
      "component": {
        "temperature": {
          "minCooling": "冷卻起始",
          "overheat": "過熱溫度",
          "warning": "警告溫度",
          "recovery": "恢復溫度",
          "misfireRange": "故障溫度範圍",
          "irStart": "紅外起始",
          "irPerKelvin": "每開紅外"
        },
        "misfire": {
          "heat": "熱量",
          "distortion": "扭曲",
          "damage": "損傷",
          "wear": "磨損",
          "window": "時間窗口",
          "hint": "遊戲檔案中給出的各項狀態閾值，達到後元件可能開始發生故障。"
        },
        "availability": {
          "retired": "價格只針對目錄目前所在的版本記錄，而該部件不在其中。",
          "craftedOnly": "沒有終端出售此物品——它由下方的配方製造。",
          "none": "沒有終端買賣此物品。"
        },
        "notRecordedYet": "僅從開始記錄之日起統計，因此部件可能尚無記錄。",
        "size": "Size: %{size}",
        "grade": "等級",
        "hidden": "隱藏?",
        "componentType": "組件類型",
        "componentSubType": "組件子類型",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "itemClass": "類別",
        "category": "分類",
        "subType": "子類型",
        "retired": "已不在目前版本中",
        "noMetrics": "該部件沒有記錄任何數據。",
        "integrity": "完整度",
        "durability": {
          "health": "耐久",
          "mass": "質量",
          "physical": "物理",
          "energy": "能量",
          "distortion": "扭曲",
          "thermal": "熱能",
          "biochemical": "生化",
          "stun": "暈眩",
          "repairTime": "修復時間",
          "repairsTo": "修復至",
          "maxRepairs": "最大修復次數",
          "disableAt": "失效閾值",
          "warningAt": "警告閾值",
          "recoversBelow": "恢復閾值",
          "decayRate": "衰減速率",
          "decayDelay": "衰減延遲"
        },
        "durabilityChanges": {
          "health": "耐久",
          "mass": "質量 (kg)",
          "resistancesPhysical": "承受物理傷害",
          "resistancesEnergy": "承受能量傷害",
          "resistancesDistortion": "承受扭曲傷害",
          "resistancesThermal": "承受熱能傷害",
          "resistancesBiochemical": "承受生化傷害",
          "resistancesStun": "承受暈眩傷害",
          "selfRepairTime": "自我修復時間 (s)",
          "selfRepairHealthRatio": "自我修復恢復至",
          "selfRepairMaxRepairs": "最大自我修復次數",
          "distortionMaximum": "扭曲失效閾值",
          "distortionWarningRatio": "扭曲警告閾值",
          "distortionRecoveryRatio": "扭曲恢復閾值",
          "distortionDecayRate": "扭曲衰減速率 (/s)",
          "distortionDecayDelay": "扭曲衰減延遲 (s)"
        }
      },
      "hardpoint": {
        "legend": {
          "headline": "圖例",
          "slotTaken": "插槽已佔用",
          "slotAvailable": "插槽可用"
        },
        "size": "尺寸",
        "rackSize": "架尺寸",
        "details": "詳情",
        "group": "群組",
        "thrusters": {
          "thrust": "推力",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix",
            "Light": "Light"
          },
          "fuelBurn": "燃料消耗",
          "mode": "模式",
          "vtolOnly": "僅限垂直起降",
          "vectorPitch": "推力向量俯仰",
          "vectorYaw": "推力向量偏航"
        },
        "refuelBoom": {
          "captureRadius": "捕捉半徑",
          "fuelFlowRate": "燃料輸送速率",
          "quantumFuelFlowRate": "量子燃料輸送速率"
        },
        "controllers": {
          "faceType": "護盾類型",
          "faces": {
            "bubble": "氣泡",
            "quadrant": "四象限"
          },
          "reconfigurationCooldown": "重新分配",
          "armedMissiles": "可武裝飛彈",
          "launchCooldown": "發射冷卻",
          "lockAngle": "鎖定角度"
        },
        "countermeasureStats": {
          "duration": "持續時間",
          "spawnDelay": "展開延遲",
          "infrared": "紅外線訊號",
          "electromagnetic": "電磁訊號",
          "crossSection": "截面訊號"
        },
        "turrets": {
          "turnRate": "轉向速率",
          "control": "操控",
          "yawRange": "偏航範圍",
          "pitchRange": "俯仰範圍",
          "limitsVary": "隨轉向變化",
          "gunPorts": "武器介面"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "爆發 DPS",
          "sustainedDps": "持續 DPS",
          "efficiency": "效率",
          "penetration": "穿透",
          "fireRate": "射速",
          "speed": "速度",
          "range": "射程",
          "ammo": "彈藥",
          "ammoCost": "彈藥成本",
          "magazineDamage": "彈匣總傷害",
          "timeToEmpty": "打空時間",
          "spread": "散布",
          "spreadFirstShot": "首發散布",
          "spreadPerShot": "散布/發",
          "spreadRecovery": "散布恢復",
          "pool": "能量池",
          "maxRegen": "最大回復/秒",
          "costPerShot": "能量/發",
          "heatPerShot": "熱量/發",
          "heatPerSecond": "熱量/秒",
          "gimbalFireRate": "射速（萬向）",
          "gimbalSpread": "散布（萬向）",
          "spreadMin": "最小",
          "spreadMax": "最大",
          "aimAssist": "瞄準輔助",
          "closeAimAssist": "近距離瞄準輔助",
          "chargeTime": "充能時間",
          "fullDamageRange": "全 DMG 距離",
          "zeroDamageRange": "零 DMG 距離",
          "damagePhysical": "物理",
          "damageEnergy": "能量",
          "damageDistortion": "扭曲",
          "damageThermal": "熱能"
        },
        "missiles": {
          "damage": "傷害",
          "speed": "速度",
          "range": "射程",
          "lockRange": "鎖定距離",
          "lockTime": "鎖定時間",
          "trackingSignal": "追蹤",
          "lockAngle": "鎖定錐角",
          "signalResilience": "訊號抗性",
          "boostPhase": "助推階段",
          "terminalPhase": "末段",
          "lifetime": "存續時間",
          "fuel": "燃料",
          "dumbfire": "無導引發射",
          "dumbfireAllowed": "允許",
          "dumbfireBlocked": "不允許",
          "blastRadius": "爆炸半徑",
          "armTime": "引信解鎖時間",
          "safetyDistance": "安全距離"
        },
        "bombs": {
          "maxDropAngle": "最大投彈角"
        },
        "missileRacks": {
          "launchDelay": "發射間隔",
          "ignition": "引擎點火",
          "ignitesOnRack": "在掛架上",
          "ignitesAfterRelease": "釋放後"
        },
        "tractorBeams": {
          "maxForce": "最大牽引力",
          "minForce": "最小牽引力",
          "range": "距離",
          "cone": "錐角",
          "tetherBreak": "繫留斷裂",
          "cargoForce": "貨物牽引力",
          "cargoRange": "貨物距離",
          "towForce": "拖曳力",
          "towDistance": "拖曳距離",
          "quantumTowMass": "QT 質量上限",
          "rotationSpeed": "旋轉",
          "moveSpeed": "移動速度"
        },
        "shields": {
          "hp": "HP",
          "regen": "回復",
          "regenTime": "回復時間",
          "downedRegenDelay": "擊潰延遲",
          "damagedRegenDelay": "受損延遲",
          "resistancePhysical": "物理抗性",
          "resistanceEnergy": "能量抗性",
          "resistanceDistortion": "扭曲抗性",
          "decay": "衰減",
          "absorption": {
            "physical": "物理吸收",
            "energy": "能量吸收",
            "distortion": "扭曲吸收"
          }
        },
        "coolers": {
          "coolingRate": "冷卻速率"
        },
        "powerPlants": {
          "output": "輸出",
          "pips": "電力格"
        },
        "flightControllers": {
          "scmSpeed": "SCM 速度",
          "boostSpeed": "加力速度",
          "navSpeed": "導航速度",
          "rotation": "俯仰 / 偏航 / 滾轉",
          "boostedRotation": "加力俯仰 / 偏航 / 滾轉",
          "boostCapacity": "加力容量",
          "boostRegen": "加力恢復",
          "boostRegenDelay": "加力恢復延遲",
          "boostRamp": "加力升 / 降時間"
        },
        "quantumDrives": {
          "speed": "速度",
          "range": "距離",
          "fuelConsumption": "消耗",
          "spoolUpTime": "預熱",
          "cooldownTime": "冷卻",
          "splineSpeed": "軌道",
          "accel": "加速度",
          "engageSpeed": "接入速度",
          "calibrationRate": "校準速率",
          "disconnectRange": "斷開距離",
          "interdictionTime": "攔截時長",
          "splineAccel": "軌道加速",
          "splineSpoolUpTime": "軌道預熱",
          "splineCooldownTime": "軌道冷卻",
          "splineInterdictionTime": "軌道攔截",
          "jumpHeat": "躍遷熱量"
        },
        "jumpDrives": {
          "fuelEfficiency": "燃料效率",
          "alignRate": "校準速率",
          "tuneRate": "調諧速率",
          "alignDecay": "校準衰減",
          "tuneDecay": "調諧衰減",
          "exitSpeed": "出口速度",
          "maxTunnelSpeed": "隧道最高速度",
          "respoolTime": "重新預熱"
        },
        "radar": {
          "aimAssistRange": "輔助範圍",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS",
          "passive": "被動探測",
          "active": "主動探測",
          "aimAssistBuffer": "輔助瞄準緩衝",
          "sensitivityModifier": "靈敏度修正",
          "contactGroups": {
            "GroundVehicle": "地面載具"
          }
        },
        "armor": {
          "hp": "HP",
          "physical": "物理",
          "energy": "能量",
          "distortion": "扭曲",
          "thermal": "熱能",
          "deflectPhysical": "物理偏轉",
          "deflectEnergy": "能量偏轉",
          "selfPhysical": "自身物理抗性",
          "selfEnergy": "自身能量抗性"
        },
        "fuelIntakes": {
          "pushRate": "輸送速率",
          "minRate": "最低速率"
        },
        "sources": {
          "game_files": "遊戲檔案",
          "ship_matrix": "Ship Matrix"
        },
        "fuelTanks": {
          "hydrogen": "氫燃料箱",
          "quantum": "量子燃料箱"
        },
        "jumpDrive": "跳躍引擎",
        "maxContainerSize": "最大貨櫃尺寸",
        "groups": {
          "avionic": "航電",
          "system": "系統",
          "propulsion": "推進",
          "thruster": "推進器",
          "weapon": "武器",
          "defense": "防禦",
          "other": "貨物",
          "auxiliary": "輔助",
          "seat": "座位",
          "external_fuel_tank": "外掛燃料箱",
          "ore_pod": "礦石艙",
          "module": "模組",
          "salvage": "打撈",
          "refuel_boom": "加油臂"
        },
        "types": {
          "radar": "雷達",
          "computers": "電腦",
          "power_plants": "發電機",
          "coolers": "冷卻器",
          "shield_generators": "護盾產生器",
          "fuel_intakes": "燃料進氣口",
          "fuel_tanks": "燃料箱",
          "quantum_drives": "量子引擎",
          "jump_modules": "跳躍模組",
          "jumpdrive": "跳躍模組",
          "quantum_fuel_tanks": "量子燃料箱",
          "main_thrusters": "主推進器",
          "maneuvering_thrusters": "機動推進器",
          "weapons": "武器",
          "turrets": "砲塔",
          "missiles": "飛彈",
          "utility_items": "實用設備",
          "utility": "實用設備",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— 選擇模組 —",
        "selectModule": "選擇模組",
        "moduleStock": "出廠狀態",
        "moduleStockHint": "插槽保持船艦出廠時的狀態",
        "categories": {
          "radar": "雷達",
          "armor": "裝甲",
          "relay": "中繼",
          "countermeasures": "反制措施",
          "lifesupport": "生命維持",
          "selfdestruct": "自毀",
          "batteries": "電池",
          "computers": "電腦",
          "powerplant": "發電機",
          "cooler": "冷卻器",
          "module": "模組",
          "shieldgenerator": "護盾產生器",
          "fuel_intakes": "燃料進氣口",
          "fueltanks": "燃料箱",
          "external_fuel_tanks": "外掛燃料箱",
          "ore_pods": "礦石艙",
          "salvage_storage": "回收儲存",
          "refuel_boom": "加油臂",
          "quantumdrive": "量子引擎與跳躍模組",
          "jump_modules": "跳躍模組",
          "jumpdrive": "跳躍模組",
          "quantum_fuel_tanks": "量子燃料箱",
          "main_thrusters": "主推進器",
          "maneuvering_thrusters": "機動推進器",
          "retro_thrusters": "反推推進器",
          "vtol_thrusters": "VTOL 推進器",
          "weapons": "武器",
          "weapon_mounts": "武器掛載",
          "turret": "砲塔",
          "missiles": "飛彈",
          "missile_racks": "飛彈架",
          "utility_items": "實用設備",
          "utility": "實用設備",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "打撈填充站",
          "cargogrid": "貨物網格",
          "controller": "飛行刀片",
          "seat": "座位",
          "thrusters": "推進器",
          "bombcompartments": "炸彈艙"
        },
        "name": "名稱",
        "category": "分類",
        "source": "來源",
        "powerConsumption": "功率消耗",
        "powerMinimumFraction": "待機功耗",
        "signatureEm": "電磁訊號",
        "signatureIr": "紅外線訊號",
        "mining": {
          "fracturePower": "破碎功率",
          "extractionPower": "提取功率",
          "range": "射程",
          "chargeTime": "充能 / 放能",
          "moduleSlots": "模組槽",
          "activation": "類型",
          "active": "主動",
          "passive": "被動",
          "charges": "使用次數",
          "duration": "持續時間",
          "modifiers": {
            "instability": "不穩定性",
            "resistance": "抗性",
            "optimalChargeWindow": "最佳充能窗口",
            "optimalChargeRate": "最佳充能速率",
            "catastrophicChargeRate": "災難性充能速率",
            "shatterDamage": "碎裂傷害",
            "inertMaterials": "惰性物質"
          }
        },
        "salvage": {
          "salvageSpeed": "打撈速度",
          "radius": "光束半徑",
          "extractionEfficiency": "提取效率"
        },
        "utility": {
          "capacity": "容量"
        },
        "selfDestruct": {
          "damage": "傷害",
          "radius": "爆炸半徑",
          "time": "引爆延時"
        },
        "quantumEnforcement": {
          "jammerRange": "干擾範圍",
          "pulseRadius": "脈衝半徑",
          "chargeTime": "充能時間",
          "cooldownTime": "冷卻時間"
        },
        "emp": {
          "distortionDamage": "扭曲傷害",
          "radius": "半徑",
          "chargeTime": "充能時間",
          "unleashTime": "釋放時間",
          "cooldownTime": "冷卻"
        },
        "lifeSupport": {
          "output": "輸出"
        },
        "powerRanges": "功率曲線（低 / 中 / 高）",
        "powerSegments": "段"
      },
      "blank": {
        "propulsion": "沒有推進系統",
        "modular": "沒有模組",
        "fleetInvites": "沒有邀請"
      },
      "user": {
        "displayName": "顯示名稱",
        "displayNameInfo": "在你的公開機庫、命名銘牌和艦隊成員列表中代替使用者名稱顯示。",
        "hangarDefaultSort": "預設順序",
        "hangarDefaultSortInfo": "按住艦船的拖曳柄即可重新排序。僅在自訂順序生效且未設定篩選時可用。",
        "hangarDefaultSortOptions": {
          "standard": "標準（旗艦優先，然後依名稱）",
          "asc": "%{field}，升冪",
          "desc": "%{field}，降冪"
        },
        "rsiHandle": "使用者名",
        "rsiHandleVerified": "已透過 Citizen iD 驗證",
        "rsiHandleVerifiedViaProfile": "已透過 RSI 個人資料驗證",
        "rsiVerification": {
          "title": "驗證你的 RSI 使用者名",
          "token": "驗證碼",
          "verifiedSince": "自 %{date} 起已驗證",
          "revokeCitizenidQuestion": "下次 Citizen iD 登入時會恢復。確定嗎？",
          "openProfileSettings": "編輯你的 RSI 個人資料",
          "steps": {
            "copy": "複製你的驗證碼",
            "paste": "將它貼到你的 RSI 個人資料的簡介中。使用者名驗證後即可將其刪除。",
            "check": "檢查 %{handle} 的公民頁面"
          },
          "extension": {
            "title": "使用 FleetYards Sync 擴充功能驗證",
            "verify": "使用擴充功能驗證",
            "description": "擴充功能會將驗證碼加入此瀏覽器所登入 RSI 帳號的簡介，檢查你的公民頁面，然後再將驗證碼移除。",
            "detecting": "正在尋找 FleetYards Sync 擴充功能",
            "install": "安裝 FleetYards Sync 擴充功能，即可一鍵驗證你的 Handle。",
            "update": "更新 FleetYards Sync 擴充功能即可一鍵驗證你的 Handle：目前安裝的版本尚不支援。",
            "handleMismatch": "此瀏覽器登入的 RSI 帳號是 %{rsiHandle}，而不是 %{handle}。請以 %{handle} 登入 RSI，或在下方手動驗證。",
            "notSignedIn": "請在此瀏覽器中登入 RSI 以使用擴充功能驗證，或在下方手動驗證。",
            "bioTooLong": "你的 RSI 簡介太長，無法加入驗證碼。請縮短簡介，或在下方手動驗證。",
            "bioUnreadable": "你的 RSI 簡介包含擴充功能無法原樣保留的格式。請在下方手動驗證。",
            "failed": "擴充功能無法更新你的 RSI 簡介。請重試，或在下方手動驗證。",
            "removeFailed": "擴充功能無法從你的 RSI 簡介中移除驗證碼。請在 RSI 上手動移除。",
            "manual": "或手動驗證："
          },
          "statuses": {
            "pending": "正在檢查你的公民頁面…",
            "token_missing": "你的簡介中還沒有該驗證碼。RSI 可能需要幾分鐘才會顯示修改。",
            "handle_mismatch": "RSI 回傳的頁面屬於另一個使用者名。",
            "not_found": "RSI 上沒有使用此使用者名的公民。",
            "failed": "無法檢查你的公民頁面。請一分鐘後重試。"
          }
        },
        "location": "位置",
        "currentSystem": "目前遊戲內位置",
        "tester": "測試者?",
        "maintainer": "維護者？",
        "avatar": "頭像",
        "unconfirmedEmail": "未確認的郵件",
        "saleNotify": "我希望收到銷售通知",
        "publicHangar": "公開機庫已啟用",
        "publicHangarLoaners": "在公開機庫顯示借用船提示",
        "publicHangarStats": "公開機庫統計已啟用",
        "publicWishlist": "公開願望清單已啟用",
        "hideOwner": "為艦隊隱藏擁有權",
        "tracking": "允許匿名使用分析",
        "showOnlineStatus": "顯示我的上線狀態",
        "supporterListed": "支持者頁面",
        "supporterListedPlatform": "依捐款時的選擇",
        "supporterListedShown": "顯示我的使用者名稱",
        "supporterListedHidden": "不顯示我",
        "onlineStatus": "上線狀態",
        "online": "線上",
        "offline": "離線",
        "lastActiveAt": "最後活躍",
        "confirmedAt": "確認於",
        "dateFormat": "日期格式",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        },
        "friendsHangar": "好友可見機庫",
        "friendsHangarStats": "好友可見機庫統計",
        "friendsWishlist": "好友可見願望清單"
      },
      "adminUser": {
        "superAdmin": "超級管理員",
        "passwordConfirmation": "確認密碼"
      },
      "vehicle": {
        "cargoWithModules": "%{cargo}（含模組 %{withModules}）",
        "customOrder": "自訂",
        "name": "名稱",
        "states": "狀態",
        "serial": "序號",
        "owner": "指揮官",
        "flagship": "旗艦",
        "wanted": "想要",
        "loaner": "借用",
        "bundled": "隨附",
        "bundledWith": "隨附於 %{parent}",
        "hiddenByUser": "已從機庫中隱藏",
        "public": "公開可見",
        "fullPublic": "公開可見（包括名稱）",
        "private": "不公開可見",
        "publicShort": "公開",
        "saleNotifyOn": "銷售通知已開啟",
        "saleNotifyOff": "銷售通知已關閉",
        "nameVisible": "公開可見",
        "hidden": "隱藏?",
        "saleNotify": "我希望收到銷售通知",
        "hangarGroups": "群組",
        "ownedPaintsSelect": {
          "label": "擁有的塗裝",
          "pledged": "來自承諾包",
          "empty": "未找到塗裝"
        },
        "modelPaintSelect": {
          "nullablePrompt": "選擇塗裝",
          "label": "塗裝"
        },
        "bulkGroupEdit": {
          "hint": "現有群組將被覆蓋！"
        },
        "hasLoaners": "借用船",
        "boughtViaSelect": {
          "label": "購買方式"
        }
      },
      "image": {
        "active": "活躍?",
        "background": "用作背景?",
        "caption": "標題",
        "enabled": "已啟用?",
        "file": "圖片檔案",
        "global": "全域?",
        "delete": "刪除",
        "start": "開始",
        "cancel": "取消",
        "processing": "處理中...",
        "error": "錯誤",
        "name": "名稱",
        "size": "檔案大小",
        "dropzone": "將圖片拖放到此處",
        "cancelUpload": "取消上傳",
        "startUpload": "開始上傳",
        "selectImages": "新增圖片...",
        "selectFolder": "新增資料夾..."
      },
      "signup": {
        "link": "還沒有帳戶?",
        "privacyPolicy": "建立 FleetYards 帳戶即表示您同意我們的"
      },
      "privacyPolicy": "隱私政策",
      "login": "使用者名稱或電子郵件",
      "username": "使用者名稱",
      "twoFactorCode": "兩步驟驗證碼",
      "confirmationCode": "確認碼",
      "email": "電子郵件",
      "avatar": "頭像",
      "alreadyRegistered": "已有帳戶?",
      "password": "密碼",
      "passwordConfirmation": "確認密碼",
      "rememberMe": "記住我",
      "emptyList": "沒有 %{name}",
      "all": "全部",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted.",
        "calendarSubscription": {
          "intro": "產生一個私人連結，把你報名的活動加入你個人的行事曆應用程式（Apple Calendar、Google Calendar、Outlook）。",
          "howTo": "把連結貼進你的行事曆應用程式的\"訂閱行事曆\"或\"以網址新增\"中。任何拿到這個連結的人都能看到你報名的活動 — 請妥善保管。"
        },
        "supporterNomination": {
          "label": "艦隊支援",
          "hint": "只要捐贈有效，其成員即可使用艦隊功能。你可以在捐贈前選擇。",
          "perDonation": "按捐贈設定",
          "perDonationHint": "單筆捐贈可以支援與常用艦隊不同的艦隊。",
          "fleet": "受支援的艦隊"
        },
        "supporterClaimKey": {
          "signedOut": "請登入以取得您的專屬支持者金鑰。",
          "patreonNote": "透過您的電子郵件連結，不需金鑰",
          "label": "您的金鑰",
          "hint": "將其貼到 PayPal、Ko-fi 或 Buy me a coffee 付款的留言中，付款即可與您的帳號連結。Patreon 則透過電子郵件連結。",
          "listed": "是否在支持者頁面上顯示您的使用者名稱由您決定：",
          "listedLink": "隱私設定"
        }
      },
      "filters": {
        "locations": {
          "name": "搜尋地點",
          "system": "星系",
          "parent": "位於",
          "kind": "類型",
          "starmap": "遊戲內地圖",
          "shownOnStarmap": "顯示在地圖上",
          "hiddenOnStarmap": "在地圖上隱藏"
        },
        "components": {
          "name": "名稱",
          "buyPriceGt": "購買價格 >=",
          "buyPriceLt": "購買價格 <=",
          "sellPriceGt": "出售價格 >=",
          "sellPriceLt": "出售價格 <=",
          "storeImageBlank": "沒有商店圖片?",
          "description": "描述",
          "manufacturer": "製造商",
          "category": "分類",
          "subType": "子類型"
        },
        "shops": {
          "name": "名稱",
          "type": "類型",
          "model": "飛船",
          "equipment": "裝備",
          "component": "組件",
          "commodity": "商品",
          "commodityType": "商品類型"
        },
        "shopCommodities": {
          "commodityType": "商品類型",
          "equipment": "裝備",
          "component": "組件",
          "commodity": "商品",
          "model": "飛船",
          "name": "名稱"
        },
        "shopItems": {
          "category": "分類",
          "subCategory": "子分類",
          "name": "名稱",
          "manufacturer": "製造商"
        },
        "stations": {
          "name": "名稱",
          "type": "太空站類型",
          "shops": "商店",
          "docks": "停靠口"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "cargoGt": "SCU >=",
          "cargoLt": "SCU <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "價格 <=",
          "priceGt": "價格 >=",
          "wanted": "想要",
          "hidden": "隱藏",
          "public": "公開",
          "group": "群組",
          "loaner": "借用船",
          "bundled": "隨附的 Snub Craft",
          "hiddenByUser": "隱藏的艦船",
          "boughtVia": "購買方式?",
          "image": "圖片",
          "imageSources": {
            "custom": "非預設",
            "upload": "已上傳",
            "gallery": "來自圖庫",
            "default": "預設"
          },
          "dedication": "命名銘牌"
        },
        "models": {
          "name": "名稱",
          "cargoGt": "SCU >=",
          "cargoLt": "SCU <=",
          "classification": "分類",
          "focus": "定位",
          "manufacturer": "製造商",
          "onSale": "販售中",
          "ingameOnly": "僅遊戲內取得",
          "canLandOnPlanets": "可在行星降落",
          "size": "尺寸",
          "dockSize": "停靠尺寸",
          "price": "價格",
          "pledgePrice": "質押價格",
          "productionStatus": "生產狀態",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "價格 <=",
          "priceGt": "價格 >=",
          "willItFit": "Will it Fit?",
          "withCargo": "有貨物?",
          "scKeyBlank": "沒有 SC Key?",
          "positionsNeedCuration": "職位需要人工校訂?",
          "fleetchartImageBlank": "沒有艦隊圖表圖片?",
          "holoBlank": "沒有 Holo?",
          "frontViewBlank": "沒有前視圖圖片?",
          "topViewColoredBlank": "沒有彩色俯視圖圖片?",
          "vehicleSize": "載具尺寸",
          "dimensionsDrifted": "尺寸與遊戲檔案不一致",
          "dimensionsMeasuredAtNull": "沒有實測尺寸?"
        },
        "modelModules": {
          "name": "名稱"
        },
        "manufacturers": {
          "name": "名稱",
          "withModels": "有型號的",
          "logoBlank": "無標誌"
        },
        "supporterContributions": {
          "name": "依名稱搜尋",
          "recurring": "定期",
          "anonymous": "匿名",
          "startedAtGteq": "開始日期從",
          "startedAtLteq": "開始日期至",
          "user": "已連結帳戶",
          "linked": "帳戶連結",
          "linkedOnly": "已連結",
          "linkedVia": "連結方式",
          "unlinkedOnly": "未連結",
          "sourceStated": "已註明平台",
          "sourceStatedOnly": "已註明平台",
          "sourceUnspecifiedOnly": "未註明平台",
          "source": "來源"
        },
        "adminNotifications": {
          "search": "搜尋"
        },
        "images": {
          "model": "飛船"
        },
        "users": {
          "search": "搜尋",
          "username": "使用者名稱",
          "email": "電子郵件",
          "rsiHandle": "RSI 使用者名"
        },
        "fleets": {
          "name": "名稱",
          "fid": "FID",
          "memberCountGteq": "最少成員數",
          "memberCountLteq": "最多成員數",
          "rsiVerified": "已通過 RSI 驗證",
          "publicFleet": "公開",
          "recruiting": "招募中",
          "createdOnGteq": "建立日期從",
          "createdOnLteq": "建立日期至",
          "member": "成員",
          "members": {
            "search": "使用者名稱或暱稱",
            "role": "角色",
            "state": "狀態",
            "acceptedAtGt": "Joined from",
            "acceptedAtLt": "Joined until",
            "invitedAtGt": "Invited from",
            "invitedAtLt": "Invited until",
            "requestedAtGt": "Requested from",
            "requestedAtLt": "Requested until",
            "declinedAtGt": "Declined from",
            "declinedAtLt": "Declined until",
            "inactiveSince": "不活躍起始日期",
            "verified": "RSI 組織",
            "verifiedYes": "已驗證",
            "verifiedNo": "未驗證",
            "withoutRsiHandle": "沒有 RSI 帳號名",
            "withoutDiscord": "未連結 Discord",
            "withoutSquadron": "未加入中隊"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          },
          "logistics": {
            "search": "搜尋物品..."
          }
        },
        "manufacturer": "製造商",
        "commodities": {
          "description": "描述",
          "traded": "有地方交易",
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "購買價格 >=",
          "buyPriceLt": "購買價格 <=",
          "sellPriceGt": "出售價格 >=",
          "sellPriceLt": "出售價格 <=",
          "storeImageBlank": "沒有商店圖片?"
        },
        "equipment": {
          "name": "名稱",
          "equipmentType": "裝備類型",
          "itemType": "物品類型",
          "weaponClass": "武器類別",
          "slot": "部位",
          "size": "尺寸",
          "grade": "等級",
          "buyPriceGt": "購買價格 >=",
          "buyPriceLt": "購買價格 <=",
          "sellPriceGt": "出售價格 >=",
          "sellPriceLt": "出售價格 <=",
          "storeImageBlank": "沒有商店圖片?",
          "subType": "子類型"
        },
        "notifications": {
          "search": "搜尋"
        },
        "blueprints": {
          "org": "發放方",
          "scKey": "遊戲鍵名",
          "withKnownSource": "有已知來源",
          "withCraftable": "產出在目錄中",
          "currentVersion": "在目前版本中",
          "name": "搜尋藍圖",
          "craftableType": "產出",
          "source": "來源",
          "withSource": "有已知來源",
          "withoutSource": "無已知來源",
          "alignment": "來源陣營",
          "material": "使用材料",
          "ownedFilter": "已擁有",
          "owned": "已擁有",
          "notOwned": "未擁有"
        },
        "missions": {
          "location": "地點",
          "ship": "你的飛船",
          "name": "搜尋任務",
          "org": "發布方",
          "standing": "聲望",
          "rewarding": "獎勵",
          "alignment": "陣營立場",
          "kind": "類型",
          "releasedFilter": "正式版",
          "released": "在正式版中",
          "unreleased": "未在正式版"
        },
        "fleetDirectory": {
          "search": "名稱、FID 或 SID",
          "memberCountGteq": "最少成員數",
          "activity": "活動",
          "language": "語言",
          "alignment": "陣營",
          "commitment": "投入程度",
          "timezone": "時區",
          "recruiting": "僅招募中",
          "roleplay": "僅角色扮演"
        }
      },
      "station": {
        "docks": "停靠口",
        "location": "位置",
        "type": "類型",
        "shops": "商店",
        "locationPrefix": {
          "default": "on",
          "orbit": "in orbit around"
        }
      },
      "tradeRoutes": {
        "intro": "依據你的飛船、預算和可接受的價格時效，找出兩個終端之間最好的一趟運輸。價格來自 UEX，每小時更新。",
        "yourRun": "你的航程",
        "ship": "飛船",
        "noShip": "選擇飛船以依每趟利潤排序",
        "noShipShort": "未選飛船",
        "scu": "%{count} SCU",
        "budget": "預算",
        "budgetPlaceholder": "選填",
        "buyIn": "購買星系",
        "anySystem": "全部",
        "commodity": "商品",
        "allCommodities": "全部商品",
        "priceAge": "價格不早於",
        "priceAges": {
          "day": "24 小時",
          "threeDays": "3 天",
          "any": "不限"
        },
        "bestRun": "最佳航程",
        "buyAt": "購買地點",
        "sellAt": "出售地點",
        "pricePerScu": "%{price} aUEC / SCU",
        "distanceValue": "%{count} Gm",
        "jumpTo": "躍遷至 %{system}",
        "pricesFrom": "價格來自 %{time}",
        "otherBuyers": {
          "one": "另有 %{count} 處收購",
          "other": "另有 %{count} 處收購"
        },
        "profitThisRun": "本趟利潤",
        "profitPerScu": "每 SCU 利潤",
        "aUecPerScu": "aUEC · 每 SCU %{value}",
        "load": "載貨量",
        "loadOf": "%{load} / %{cargo} SCU",
        "thisShip": "此飛船",
        "unflyable": {
          "origin": "%{ship} 無法在 %{terminal} 降落",
          "destination": "%{ship} 無法在 %{terminal} 降落",
          "both": "%{ship} 在兩端都無法降落"
        },
        "loadLimits": {
          "hold": "貨艙已滿",
          "stock": "受庫存限制",
          "demand": "受需求限制",
          "budget": "受預算限制"
        },
        "youSpend": "花費",
        "pickShipForRun": "選擇飛船以查看一趟的利潤。",
        "moreRuns": "更多航程",
        "runs": "航程",
        "rankBy": "排序依據",
        "profitPerRun": "每趟利潤",
        "profitPerDistance": "每 Gm 利潤",
        "shortest": "最短",
        "buySell": "買入 → 賣出",
        "spend": "花費",
        "distance": "距離",
        "prices": "價格",
        "profit": "利潤",
        "to": "至",
        "everyBuyer": "從 %{terminal} 收購 %{commodity} 的所有地點",
        "empty": "沒有符合的航程。試試更早的價格或其他星系。",
        "loadExplained": "載貨量依兩個終端和商品都接受的貨箱尺寸計算，並受購買地庫存、出售地需求和你的預算限制。",
        "poweredByUex": "價格由 UEX 提供"
      },
      "hardpoints": {
        "prefix": "使用以下工具試用配置",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "數據基於以下網站的計算公式"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "選擇飛船"
      },
      "table": {
        "selected": "%{count} 已選擇",
        "selectRow": "選擇列",
        "selectAll": "選擇所有列"
      },
      "commodityPrice": {
        "item": "ShopCommodity",
        "price": "價格",
        "type": "類型",
        "shop": "商店"
      },
      "hangarPledgeItems": {
        "openOnRsi": "在 RSI 機庫中開啟",
        "flair": "機庫裝飾",
        "upgrades": "升級 / CCU",
        "equipment": "FPS 裝備",
        "createdOn": "建立於",
        "meltable": "可熔煉",
        "withValue": "有熔煉價值",
        "paints": "塗裝",
        "pledge": "承諾 %{id}",
        "meltValue": "熔煉價值",
        "partOf": "屬於 %{name}",
        "pledgeValue": "承諾價值",
        "quantity": "數量",
        "search": "按名稱搜尋",
        "shipComponents": "飛船部件",
        "addToInventory": "加入庫存",
        "inventory": "庫存",
        "inInventory": "位於 %{name}",
        "select": "選擇",
        "andMore": {
          "other": "以及另外 %{count} 項"
        }
      },
      "buybacks": {
        "name": "可回購承諾",
        "search": "搜尋可回購承諾",
        "kind": "類型",
        "kinds": {
          "package": "禮包",
          "ship": "單船",
          "upgrade": "升級",
          "paint": "塗裝",
          "addon": "附加內容",
          "other": "其他"
        },
        "upgraded": "已升級",
        "reclaimedOn": "熔煉於",
        "notAvailable": "無法使用",
        "price": "價格",
        "insurance": "保險",
        "lifetimeInsurance": "終身保險",
        "noInsurance": "無保險",
        "insuranceMonths": {
          "one": "%{count} 個月",
          "other": "%{count} 個月"
        },
        "openOnRsi": "在 RSI 回購",
        "remove": "移除",
        "priceRange": "價格範圍",
        "priceMin": "最低價格（USD）",
        "priceMax": "最高價格（USD）",
        "upgradeFrom": "升級自",
        "upgradeTo": "升級至",
        "gets": "可取得該艦船"
      },
      "buybackSync": {
        "extensionVersion": "已安裝的擴充功能版本",
        "detailsProgress": "正在讀取回購價格",
        "pages": "頁數",
        "added": "新增",
        "removed": "已移除",
        "prices": "已讀取價格",
        "background": {
          "finished": "回購同步已完成",
          "incomplete": "回購同步已完成，部分價格缺失",
          "unsupported": "回購同步需要較新版本的擴充功能",
          "failed": "回購同步失敗"
        },
        "status": {
          "fetching": "正在讀取回購頁面",
          "submitting": "正在儲存",
          "finished": "已完成",
          "unsupported": "不支援",
          "failed": "失敗"
        },
        "stepDetails": {
          "saved": "新增：%{added} · 移除：%{removed}",
          "prices": "%{done} / %{total}",
          "pricesPending": "針對上次同步後新增的承諾",
          "read": "已讀取頁數：%{page} · 可回購承諾：%{count}"
        },
        "firstSyncTitle": "首次同步耗時較長",
        "updateExtensionTitle": "更新同步擴充功能",
        "finishedTitle": "可回購承諾已同步",
        "runningTitle": "正在同步可回購承諾",
        "pledges": "可回購承諾"
      },
      "syncExtension": {
        "warnings": "警告",
        "backgroundProgress": "正在同步機庫",
        "backgroundFinished": "機庫同步已完成",
        "backgroundFailed": "機庫同步失敗",
        "backgroundCancelled": "機庫同步已取消",
        "status": {
          "failed": "匯入失敗!",
          "cancelled": "匯入已取消"
        },
        "processSteps": {
          "fetchHangar": "正在讀取你的 RSI 機庫",
          "submitData": "正在儲存到 Fleetyards"
        },
        "signedInAs": "已以 %{handle} 登入 RSI",
        "signInToRsi": "登入 RSI",
        "checkIdentity": "檢查 RSI 工作階段",
        "targetGroup": "找到的飛船歸入的分組",
        "addBundledVehicles": "新增附帶的小型飛船",
        "addBundledVehiclesHint": "新增飛船附帶的小型飛船。已在機庫中的會保留。",
        "syncPaints": "同步塗裝",
        "syncPaintsHint": "以你 RSI 機庫中的塗裝取代已儲存的塗裝。關閉時保留已儲存的塗裝不變。",
        "syncHangarFlair": "同步機庫裝飾",
        "syncHangarFlairHint": "以你 RSI 機庫中的機庫裝飾取代已儲存的裝飾。關閉時保留已儲存的裝飾不變。",
        "syncCcus": "同步 CCU",
        "syncCcusHint": "以你 RSI 機庫中的 CCU 取代已儲存的 CCU。關閉時保留已儲存的 CCU 不變。",
        "syncEquipment": "同步 FPS 裝備",
        "syncEquipmentHint": "以你 RSI 機庫中的 FPS 裝備取代已儲存的裝備。關閉時保留已儲存的裝備不變。",
        "settings": "設定",
        "unmatchedVehiclesAction": "不在 RSI 機庫中的飛船",
        "unmatchedVehiclesActionHint": "如何處理這裡有、但同步在你的 RSI 認購清單中找不到的飛船。",
        "unmatchedHangarGroup": "歸入的分組",
        "unmatchedHangarGroupHint": "飛船保持原樣，只是收集到這個分組裡，方便你逐一處理。",
        "unmatchedVehiclesActions": {
          "wishlist": "移至願望清單",
          "delete": "刪除",
          "keep": "保持不變",
          "group": "歸入一個分組"
        },
        "identityStatus": {
          "pending": "檢查中...",
          "notFound": "未找到",
          "connected": "已連接"
        },
        "platforms": {
          "chrome": "Google Chrome or Chromium based Browsers",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "頁面",
          "paints": "塗裝",
          "hangarFlair": "機庫裝飾",
          "paintsNotSynced": "塗裝（不會同步）",
          "hangarFlairNotSynced": "機庫裝飾（不會同步）",
          "equipment": "FPS 裝備",
          "ccus": "升級 / CCU",
          "ccusNotSynced": "CCU（未同步）",
          "equipmentNotSynced": "FPS 裝備（不會同步）",
          "extras": "其他",
          "shipComponents": "飛船部件",
          "shipComponentsNotSynced": "飛船部件（未同步）"
        },
        "importedItems": {
          "importedVehicles": "已新增飛船",
          "foundVehicles": "找到的飛船",
          "movedVehiclesToWanted": "飛船已移至願望清單",
          "deletedVehicles": "已刪除的飛船",
          "groupedVehicles": "已歸入分組的飛船",
          "unchangedVehicles": "保持不變的飛船",
          "missingModels": "未找到飛船",
          "importedComponents": "已新增組件",
          "foundComponents": "找到的組件",
          "missingComponents": "未找到組件",
          "missingComponentVehicles": "未找到匹配的飛船用於組件",
          "importedUpgrades": "已新增升級",
          "foundUpgrades": "找到的升級",
          "syncedPaints": "已同步塗裝",
          "syncedHangarFlair": "已同步機庫裝飾",
          "syncedCcus": "已同步 CCU",
          "syncedEquipment": "已同步 FPS 裝備",
          "missingUpgrades": "未找到升級",
          "missingUpgradeVehicles": "未找到匹配的飛船用於升級"
        },
        "incomplete": "您的 RSI 機庫中有部分物品無法讀取，因此本次未找到的飛船保持不變。",
        "stepDetails": {
          "read": "已讀取頁數：%{pages} · 承諾：%{count}",
          "saving": "正在將你的承諾與機庫比對…",
          "page": "第 %{page} 頁",
          "pageOf": "第 %{page} 頁，共 %{total} 頁",
          "sending": {
            "other": "正在傳送 %{count} 項"
          },
          "sent": {
            "other": "已傳送 %{count} 項"
          },
          "pageOfAbout": "第 %{page} 頁，共約 %{total} 頁"
        },
        "unmatchedCount": {
          "one": "有 1 項無法比對",
          "other": "有 %{count} 項無法比對"
        },
        "unmatchedHeading": "無法比對",
        "failedStep": {
          "fetchHangar": "讀取你的 RSI 機庫失敗",
          "submitData": "儲存到 Fleetyards 失敗"
        },
        "whatToSync": "同步內容",
        "unmatchedActionLabel": "如何處理它們",
        "notSyncing": "不同步",
        "targetGroupHint": "同步找到或加入的每艘艦船都會歸入此分組，並保留它原有的分組。",
        "extensionNeededTitle": "新增同步擴充功能",
        "finishedTitle": "機庫已同步",
        "failedTitle": "同步未完成",
        "savedAsYouChange": "變更後即自動儲存",
        "resultKinds": {
          "ships": "飛船",
          "components": "模組",
          "upgrades": "升級",
          "paints": "塗裝",
          "hangarFlair": "機庫裝飾",
          "equipment": "FPS 裝備",
          "ccus": "CCU",
          "shipComponents": "飛船部件"
        },
        "newCount": {
          "one": "新增 1",
          "other": "新增 %{count}"
        },
        "resultActions": {
          "movedVehiclesToWanted": "已移至願望清單",
          "deletedVehicles": "已刪除",
          "groupedVehicles": "已歸入分組",
          "unchangedVehicles": "保持不變"
        },
        "nothingChangedTitle": "沒有任何變更",
        "stepStatus": {
          "pending": "未開始",
          "active": "進行中",
          "done": "已完成",
          "failed": "失敗",
          "warning": "已完成，但有警告"
        },
        "lastSync": {
          "of": "/ %{count}",
          "ofLong": "上次同步為 %{count}",
          "more": "比上次同步多 %{count}",
          "fewer": "比上次同步少 %{count}",
          "same": "與上次同步相同",
          "reading": "%{count} / 約 %{total} 項"
        },
        "viewImport": "檢視本次同步的匯入",
        "lastSynced": "上次同步：",
        "syncShipComponents": "同步飛船部件",
        "syncShipComponentsHint": "用你 RSI 機庫中的飛船部件（冷卻器、發電機、武器等）取代已儲存的部件。關閉時保留已儲存的飛船部件。"
      },
      "cargoGridViewer": {
        "capacity": "容量",
        "maxContainerSize": "最大貨櫃",
        "packed": "已裝載",
        "totalCargo": "總貨物",
        "didNotFit": "放不下",
        "enoughShips": "四艘飛船已填滿網格。",
        "addShip": "新增飛船",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "travelTimes": {
        "quantumDrive": "量子引擎",
        "fuelUsage": "燃料消耗",
        "travelTime": "旅行時間",
        "poweredBy": "基於",
        "rank": "#",
        "size": "尺寸",
        "grade": "等級",
        "sizeValue": "S%{size}",
        "intro": "每台量子引擎完成這次躍遷需要多久——以及消耗多少量子燃料。",
        "jumpDistance": "躍遷距離",
        "distanceHint": "1 Mkm 即一百萬公里。橫越斯坦頓約需 40。",
        "filters": "篩選",
        "resetFilters": "重設",
        "barLegend": "長條表示相對最慢引擎的時間",
        "count": "%{count} 台引擎",
        "countFiltered": "%{total} 台中的 %{count} 台",
        "noMatch": "沒有引擎符合這些篩選條件。",
        "presets": {
          "moon": "月球距離",
          "short": "短距躍遷",
          "system": "橫越斯坦頓",
          "far": "長途"
        }
      },
      "admin": {
        "importLoaders": {
          "ship_matrix_all": {
            "name": "全部",
            "description": "艦船、模組、塗裝、借用艦船和艦船價格，一次全部載入。"
          },
          "ship_matrix": {
            "name": "艦船",
            "description": "來自 RSI 艦船矩陣的全部艦船及其資料與商店資訊。"
          },
          "modules": {
            "name": "模組",
            "description": "來自 RSI 商店的艦船模組。"
          },
          "paints": {
            "name": "塗裝",
            "description": "來自 RSI 商店的塗裝。"
          },
          "loaners": {
            "name": "借用艦船",
            "description": "每艘艦船附帶哪些借用艦船，來自 RSI。"
          },
          "uex_vehicle_prices": {
            "name": "艦船價格",
            "description": "遊戲內購買和租用艦船的地點，來自 UEX。"
          },
          "sc_data": {
            "name": "遊戲資料 · %{environment}",
            "description": "解析後遊戲檔案中的全部目錄：元件、裝備、商品、藍圖、任務和地點。"
          },
          "sc_data_models": {
            "name": "遊戲檔案中的艦船",
            "description": "僅艦船，來自預設版本。"
          },
          "uex_commodity_prices": {
            "name": "商品價格",
            "description": "終端價格和庫存，來自 UEX。"
          },
          "uex_component_prices": {
            "name": "元件價格",
            "description": "元件的出售地點，來自 UEX。"
          },
          "uex_equipment_prices": {
            "name": "裝備價格",
            "description": "裝備的出售地點，來自 UEX。"
          },
          "uex_trade_routes": {
            "name": "終端和貿易路線",
            "description": "UEX 的終端及其之間的貿易路線。"
          },
          "environments": {
            "live": "Live",
            "ptu": "PTU"
          }
        },
        "locations": {
          "parent": "上級",
          "system": "星系",
          "scKey": "遊戲鍵",
          "scRefs": "遊戲參照",
          "slug": "Slug",
          "gameType": "遊戲類型",
          "build": "版本",
          "children": "內部地點",
          "missions": "關聯任務",
          "missionTemplates": "任務範本",
          "shownWithParentOnly": "僅隨上級顯示",
          "yes": "是",
          "no": "否",
          "unavailable": "無法使用",
          "appearance": "外觀",
          "image": "圖片",
          "color": "顏色",
          "appearanceHint": "顏色會填滿行星或衛星的圓圈，並渲染成受光照的球體。留空時，會在上傳圖片時從圖片中擷取。",
          "headerImageHint": "圖片會作為該地點頁面的頁首圖片顯示。",
          "shops": "商店",
          "shopImageHint": "圖片會作為商店頁面的頁首圖片顯示。",
          "sunHint": "顏色會為恆星的光暈著色。"
        },
        "blueprints": {
          "status": {
            "sourceKnown": "來源已知",
            "outputResolved": "產出在目錄中"
          },
          "columns": {
            "source": "來源",
            "output": "產出",
            "build": "版本",
            "created": "建立於",
            "slot": "槽位",
            "material": "材料",
            "type": "類型",
            "quantity": "數量",
            "minQuality": "最低品質",
            "stat": "屬性",
            "change": "變化",
            "base": "基準",
            "ramp": "曲線",
            "kind": "類別",
            "org": "組織",
            "mission": "任務",
            "standing": "聲望",
            "pool": "獎勵池"
          },
          "makes": "產出",
          "noOutput": "不在任何目錄中",
          "slug": "Slug",
          "scKey": "遊戲鍵名",
          "scRef": "遊戲參考",
          "build": "版本",
          "state": "狀態",
          "states": {
            "current": "目前",
            "retired": "已移除"
          },
          "createdAt": "建立於",
          "updatedAt": "更新於"
        },
        "missions": {
          "unnamed": "遊戲從未命名",
          "slug": "Slug",
          "scKey": "遊戲鍵",
          "scRef": "遊戲參照",
          "generator": "產生器",
          "debugName": "除錯名稱",
          "build": "版本",
          "difficultyAxes": "難度（技巧 / 負擔 / 風險 / 理解）",
          "state": "狀態",
          "states": {
            "retired": "已移除",
            "released": "在正式版",
            "unreleased": "未在正式版"
          },
          "columns": {
            "released": "在正式版",
            "generator": "產生器",
            "build": "版本",
            "rewardKind": "類型",
            "amount": "數量",
            "rewardDetail": "詳情"
          },
          "filters": {
            "debugName": "除錯名稱",
            "named": "已命名",
            "unnamed": "從未命名",
            "namedFilter": "命名",
            "currentBuild": "僅目前版本",
            "anyBuild": "任何版本",
            "build": "版本"
          }
        },
        "dashboard": {
          "quickStats": {
            "onlineUsers": "線上使用者"
          }
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "kofi": "Ko-fi",
            "buymeacoffee": "Buy me a coffee",
            "paypal": "PayPal",
            "other": "其他"
          },
          "linkedVia": {
            "patreon_account": "Patreon 帳戶",
            "claim_key": "支持者權杖",
            "payer_email": "付款人電子郵件",
            "manual": "管理員設定"
          }
        },
        "announcements": {
          "columns": {
            "title": "標題",
            "status": "狀態",
            "deliveries": "管道",
            "recipients": "接收人數",
            "publishedAt": "發送時間"
          },
          "statuses": {
            "draft": "草稿",
            "scheduled": "已排程",
            "publishing": "發送中",
            "published": "已發送",
            "failed": "失敗"
          },
          "channels": {
            "in_app": "應用內",
            "discord": "Discord",
            "bluesky": "Bluesky"
          },
          "deliveryStatuses": {
            "pending": "待處理",
            "succeeded": "已發送",
            "skipped": "已略過",
            "failed": "失敗"
          },
          "lastTested": "上次測試 %{time}",
          "noChannel": "至少選擇一個管道。",
          "notifyUsersInfo": "僅已開啟的人收到郵件。",
          "discordPartsInfo": "留空：自動拆分。",
          "socialPartsInfo": "留空：一則貼文，超長截斷。兩則以上：討論串。",
          "recipientsCount": "%{count} 位收件人",
          "partPosition": "第 %{position} / %{total} 則",
          "deliverySummary": "已傳送 %{sent}/%{total}",
          "deliveryFailedCount": "%{count} 個失敗",
          "deliveryPendingCount": "%{count} 個待處理",
          "deliverySkippedCount": "%{count} 個已略過",
          "attempts": "嘗試 %{count} 次",
          "content": "內容",
          "manualPostsInfo": "發送到 Bluesky 的文字，可手動發佈到 X 或其他平台。",
          "engagement": {
            "likes": "按讚",
            "reposts": "轉發",
            "replies": "回覆",
            "quotes": "引用",
            "noReactions": "尚無表情回應。",
            "fetchedAt": "更新於 %{time}",
            "notFetched": "數據將在一小時內送達。",
            "untracked": "發布時尚未記錄表情回應。"
          }
        },
        "resourceAccess": {
          "title": "資源存取權",
          "groups": {
            "ship_data": "飛船資料",
            "community": "社群",
            "system": "系統"
          },
          "privileges": {
            "locations": "地點",
            "blueprints": "藍圖",
            "models": "型號",
            "model_modules": "型號模組",
            "components": "組件",
            "manufacturers": "製造商",
            "vehicles": "載具",
            "images": "圖片",
            "fleets": "艦隊",
            "users": "使用者",
            "supporters": "支持者",
            "admins": "管理員",
            "announcements": "公告",
            "oauth_applications": "OAuth 應用程式",
            "maintenance": "維護",
            "imports": "匯入",
            "features": "功能",
            "workers": "背景工作",
            "pghero": "PgHero",
            "rsi-api-status": "RSI API 狀態",
            "stats": "統計"
          }
        },
        "versions": {
          "blank": "空白",
          "revertQuestion": "要還原嗎？",
          "sources": {
            "custom": "管理員",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "遊戲檔案",
            "sc_loader": "遊戲檔案",
            "uex_price_sync": "UEX 價格同步",
            "unknown": "未知"
          }
        },
        "models": {
          "unlisted": "未收錄"
        }
      },
      "hangarTable": {
        "extraColumns": "欄",
        "columns": {
          "storeImage": "圖片",
          "storeImageWide": "寬圖片",
          "angledView": "3D 圖片",
          "angledViewWide": "寬 3D 圖片",
          "modelManufacturerName": "製造商",
          "modelLength": "長度",
          "modelBeam": "寬度",
          "modelHeight": "高度",
          "modelMass": "質量",
          "modelCargo": "貨物",
          "modelCrew": "船員",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "最大速度",
          "modelGroundMaxSpeed": "地面速度",
          "modelFocus": "定位",
          "modelProductionStatus": "生產狀態",
          "modelPrice": "價格",
          "modelPledgePrice": "質押價格"
        }
      },
      "fleetTable": {
        "extraColumns": "欄",
        "columns": {
          "storeImage": "圖片",
          "storeImageWide": "寬圖片",
          "angledView": "3D 圖片",
          "angledViewWide": "寬 3D 圖片",
          "modelManufacturerName": "製造商",
          "modelLength": "長度",
          "modelBeam": "寬度",
          "modelHeight": "高度",
          "modelMass": "質量",
          "modelCargo": "貨物",
          "modelCrew": "船員",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "最大速度",
          "modelGroundMaxSpeed": "地面速度",
          "modelProductionStatus": "生產狀態",
          "modelPrice": "價格",
          "modelPledgePrice": "質押價格",
          "owner": "擁有者",
          "vehiclesCount": "數量"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "entriesCount": "entries",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "componentCategory": "組件類型",
        "commodityType": "商品類型",
        "equipmentItemType": "裝備類型",
        "crafted": {
          "request": "要求製作的部件",
          "page": "由 %{recipe} 以品質 %{grades} 製作。醒目標示的數值與目錄不同。",
          "showStock": "顯示原廠數值",
          "edit": "記錄製作方式",
          "summary": "已製作 %{grades}",
          "lot": "已製作",
          "grade": "品質 %{quality}",
          "slotGrade": "槽位 %{position}：%{quality}"
        },
        "itemPicker": {
          "field": "物品",
          "placeholder": "選擇物品",
          "custom": "將「%{name}」新增為自訂物品",
          "search": "按名稱搜尋",
          "chooseCategory": "選擇一個類別以瀏覽其物品。",
          "results": {
            "one": "%{count} 件物品",
            "other": "%{count} 件物品"
          },
          "noResults": "沒有符合這些篩選條件的物品。",
          "clear": "移除目錄物品",
          "capacity": "容量"
        },
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "description": "Description",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "general": "General"
        },
        "priorities": {
          "standard": "Standard",
          "critical": "Critical"
        },
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityShort": "品質 %{quality}",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only",
          "squadron_only": "僅中隊"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "lots": "批次",
        "linkedItem": "Linked item",
        "catalogueIdentity": "名稱和類別取自關聯的目錄物品。",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "openInCatalogue": "在目錄中開啟",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "超出貨艙容量",
        "cargoGrid": "貨艙網格",
        "shipInventory": "飛船庫存",
        "remaining": "剩餘",
        "unmeasured": "%{count} 項尚未測量",
        "transferTarget": "接收方",
        "transferNote": "備註",
        "noStock": "沒有可移動的物品",
        "overStock": "超過該條目的庫存",
        "incoming": "接收",
        "outgoing": "發出",
        "transferStates": {
          "pending": "等待中",
          "completed": "已送達",
          "declined": "已拒絕",
          "cancelled": "已撤回",
          "expired": "已過期"
        },
        "acceptInto": "接收至",
        "reportReason": "原因",
        "reportReasons": {
          "spam": "垃圾訊息",
          "harassment": "騷擾",
          "scam": "詐騙",
          "other": "其他"
        },
        "transferToFleet": "%{fleet}（艦隊）",
        "sender": "來自",
        "recipient": "傳往",
        "contents": "內容",
        "state": "狀態",
        "sentAt": "傳送時間",
        "transferKinds": {
          "inventory": "我的庫存",
          "fleet": "艦隊",
          "user": "某人",
          "mine": "我的庫存",
          "fleetInventories": "該艦隊",
          "contract": "我參與的合約"
        },
        "transferTargetKind": "傳送至",
        "contractDeliveryTarget": "%{contract}（%{fleet}）：%{destination}",
        "transferFromFleet": "來自艦隊",
        "noTransferTargets": "這裡沒有可傳送的目標",
        "recordedAt": "記錄時間",
        "origin": "來自 / 傳往",
        "inTransitAmount": "%{amount} 運送中",
        "inTransitHint": "已隨一筆尚未被回覆的轉移送出，已不計入上方總數。",
        "transferFromFriends": "我的好友",
        "towardsContract": "計入合約",
        "noContract": "不計入合約",
        "forContract": "用於"
      },
      "hangarInventories": "Inventories",
      "adminNotifications": {
        "inbox": "收件匣",
        "archive": "封存",
        "unreadOnly": "僅未讀",
        "status": "狀態",
        "severity": "嚴重程度",
        "type": "類型",
        "selectPrompt": "選擇一則通知來閱讀",
        "noBody": "這則通知沒有更多細節。",
        "lastSeen": "最後出現",
        "expires": "到期",
        "severities": {
          "info": "資訊",
          "warning": "警告",
          "error": "錯誤"
        },
        "types": {
          "paints_import": "塗裝匯入",
          "modules_import": "模組匯入",
          "loaner_sync": "借用船同步",
          "uex_prices_import": "UEX 價格同步",
          "uex_commodity_prices_import": "UEX 商品同步",
          "uex_component_prices_import": "UEX 部件同步",
          "uex_equipment_prices_import": "UEX 裝備同步",
          "uex_trade_routes_sync": "UEX 貿易路線同步",
          "new_supporter": "新支持者",
          "rsi_api_blocked": "RSI API 已封鎖",
          "rsi_api_unblocked": "RSI API 已恢復",
          "rsi_markup_changed": "RSI 頁面已變更",
          "weekly_stats": "每週報告",
          "ship_matrix_import": "Ship Matrix 匯入",
          "sc_data_import": "sc_data 匯入",
          "sc_data_unlisted_models": "未收錄飛船",
          "import_run": "匯入",
          "oauth_application_review": "OAuth 應用審核",
          "inventory_transfer_reports": "被檢舉的庫存轉移"
        }
      },
      "optional": "選填",
      "notificationActions": {
        "open": "開啟",
        "openHangar": "開啟機庫",
        "openModel": "顯示飛船",
        "openInvite": "檢視邀請",
        "reviewRequest": "審核申請",
        "openMembers": "顯示成員",
        "openFleet": "開啟艦隊",
        "openInventory": "開啟庫存",
        "openEvent": "開啟活動",
        "openRoster": "顯示報名名單",
        "addToCalendar": "加入行事曆",
        "openStore": "質押商店",
        "accept": "接受",
        "decline": "拒絕",
        "signUp": "報名",
        "withdraw": "取消報名",
        "syncAgain": "再次同步",
        "markAsBought": "標示為已購買",
        "unavailable": "這項內容已無法使用。",
        "openTransfers": "開啟轉移",
        "openFriends": "開啟好友",
        "openAllies": "開啟盟友",
        "openTour": "開啟行程",
        "openSquadron": "開啟中隊",
        "openContract": "開啟合約",
        "openPayouts": "打開分帳"
      },
      "notificationTypes": {
        "channels": {
          "app": "App",
          "mail": "郵件",
          "push": "推播",
          "discord": "Discord"
        },
        "groups": {
          "account": "帳戶與機庫",
          "announcements": "公告",
          "fleetMembership": "艦隊成員資格",
          "fleetEvents": "艦隊活動",
          "logistics": "物流",
          "relationships": "好友與盟友",
          "tours": "行程",
          "fleetContracts": "艦隊合約"
        },
        "announcement": "公告",
        "hangar_sync_finished": "機庫同步完成",
        "hangar_sync_failed": "機庫同步失敗",
        "model_on_sale": "型號特價中",
        "new_model": "新型號發布",
        "fleet_invite": "收到艦隊邀請",
        "fleet_member_requested": "已申請加入",
        "fleet_member_accepted": "會員資格已接受",
        "fleet_request_accepted": "加入申請已通過",
        "fleet_joined_by_discord_role": "透過 Discord 身分組加入",
        "fleet_inventory_item_added": "艦隊庫存已新增物品",
        "fleet_event_published": "活動已發布",
        "fleet_event_locked": "活動報名已鎖定",
        "fleet_event_starting_soon": "活動即將開始",
        "fleet_event_started": "活動已開始",
        "fleet_event_completed": "活動已完成",
        "fleet_event_cancelled": "活動已取消",
        "fleet_event_signup_added": "新報名",
        "fleet_event_signup_withdrawn": "報名已取消",
        "fleet_event_signup_confirmed": "報名已確認",
        "fleet_event_signup_assigned": "已指派席位",
        "fleet_event_signup_kicked": "已從席位移除",
        "allInGroup": "這個群組的全部項目",
        "inventory_transfer_received": "收到轉移",
        "inventory_transfer_resolved": "轉移已回覆",
        "friend_request_received": "收到好友請求",
        "friend_request_accepted": "好友請求已接受",
        "fleet_ally_request_received": "收到結盟請求",
        "fleet_ally_request_accepted": "結盟請求已接受",
        "tour_join_request_received": "收到參加申請",
        "tour_join_request_accepted": "參加申請已通過",
        "fleet_squadron_request_received": "中隊加入申請",
        "fleet_squadron_request_accepted": "中隊申請已通過",
        "fleet_contract_published": "合約已發布",
        "fleet_announcement_posted": "公告已發布",
        "fleet_contract_claimed": "合約已接取",
        "fleet_contract_crew_requested": "有人想加入合約",
        "fleet_contract_crew_answered": "合約成員申請已處理",
        "fleet_subscription_started": "已獲得艦隊功能",
        "fleet_subscription_ended": "已失去艦隊功能",
        "fleet_fid_claim_opened": "艦隊 ID 被申領",
        "fleet_fid_claim_completed": "艦隊 ID 已轉移",
        "fleet_fid_claim_cancelled": "艦隊 ID 申領已結束",
        "fleet_rsi_verification_lost": "艦隊驗證已失效",
        "rsi_handle_verification_lost": "RSI 使用者名驗證已失效",
        "fleet_contract_fulfilled": "合約已完成",
        "fleet_contract_settled": "合約已結算",
        "payout_ledger_settled": "分帳已結算",
        "payout_entry_pending_review": "支出待審核",
        "payout_entry_declined": "支出已拒絕",
        "fleet_verification_requested": "你的艦隊請求驗證"
      },
      "fleets": {
        "missions": {
          "untitled": "未命名任務",
          "title": "標題",
          "description": "描述",
          "team": "隊伍",
          "teams": "隊伍",
          "ship": "飛船",
          "ships": "飛船",
          "slot": "席位",
          "slots": "席位",
          "noMissions": "尚無任務。",
          "noTeams": "尚未新增任何隊伍。",
          "noShips": "尚未新增任何飛船。",
          "noSlots": "尚未新增任何席位。",
          "archivedTab": "已封存",
          "activeTab": "進行中",
          "archived": "已封存",
          "modelSpecific": "指定飛船",
          "modelList": "任選其一",
          "modelListHint": "這個位置由你挑選的任一艘飛船擔任皆可。",
          "allowedShips": "符合條件的飛船",
          "anyOf": "任一",
          "filterRange": "篩選範圍",
          "classification": "分類",
          "focus": "定位",
          "minSize": "最小尺寸",
          "maxSize": "最大尺寸",
          "minCrew": "最少船員",
          "minCrewOverride": "覆寫",
          "minCrewOverrideLabel": "最少船員覆寫",
          "minCrewOverrideHint": "留空即使用飛船的船員數。",
          "minCargo": "最少貨物（SCU）",
          "createdBy": "建立者",
          "seats": "座位",
          "category": "分類",
          "coverImage": "封面圖片",
          "scenario": "情境",
          "categories": {
            "other": "其他",
            "ship_combat": "艦船戰鬥",
            "ground_combat": "地面戰鬥",
            "combined_combat": "聯合作戰",
            "mining": "採礦",
            "salvage": "打撈",
            "cargo_hauling": "貨運",
            "exploration": "探索"
          }
        },
        "events": {
          "untitled": "未命名活動",
          "title": "標題",
          "description": "描述",
          "briefing": "簡報",
          "startsAt": "開始時間",
          "endsAt": "結束時間",
          "timezone": "時區",
          "location": "活動地點",
          "meetupLocation": "集合地點",
          "visibility": "可見範圍",
          "maxAttendees": "人數上限",
          "autoLockEnabled": "自動鎖定報名",
          "autoLockMinutesBefore": "開始前幾分鐘鎖定",
          "recurring": "重複",
          "recurringHint": "依重複排程自動產生這個活動。成員需要針對每一場分別報名。",
          "recurringSummary": "重複頻率：%{interval}",
          "recurringUntil": "重複頻率：%{interval}，直到 %{date}",
          "recurringForCount": "重複頻率：%{interval}（共 %{count} 場）",
          "viewSeries": "檢視系列",
          "recurrenceInterval": "重複間隔",
          "recurrenceEnd": "結束",
          "recurrenceEndNever": "永不",
          "recurrenceEndOn": "在指定日期",
          "recurrenceEndAfter": "經過",
          "recurrenceEndOccurrences": "場",
          "recurrenceUnit": {
            "daily": "天",
            "weekly": "週",
            "monthly": "個月"
          },
          "recurrenceWeekdays": "重複日",
          "recurrenceWeekdaysHint": "活動開始的那一天一律包含在內。",
          "recurrence": {
            "daily": "每天",
            "weekly": "每週",
            "monthly": "每月",
            "everyN": {
              "daily": "每%{count}天",
              "weekly": "每%{count}週",
              "monthly": "每%{count}個月"
            },
            "onDays": "%{interval}（%{days}）"
          },
          "occurrencesSection": "即將到來的場次",
          "skipOccurrence": "略過這一場",
          "overrideOccurrence": "覆寫 %{date} 的場次",
          "overrideOccurrenceShort": "編輯這一場",
          "overrideOccurrenceHint": "只為這一場覆寫欄位。留空則沿用重複活動的設定。",
          "endSeriesHere": "從這裡起停止",
          "splitSeriesHere": "編輯此場及之後的場次",
          "splitSeriesConfirm": "從此日期起將該系列作為新活動繼續？此場及之後場次的報名會一併轉移，新活動將開啟以供編輯。",
          "excludedBadge": "已略過",
          "noUpcomingOccurrences": "未來 12 週內沒有即將到來的場次。",
          "endSeriesConfirm": "要在這個日期之後停止重複嗎？之後的場次將不會再產生。",
          "skipOccurrenceSuccess": "已略過這一場。",
          "unskipOccurrence": "恢復這一場",
          "unskipOccurrenceSuccess": "已恢復這一場。",
          "endSeriesSuccess": "系列已從這個日期起結束。",
          "cancelledReason": "取消原因",
          "createdBy": "建立者",
          "signups": "報名",
          "signupsCount": "%{count} 筆報名",
          "youAreHere": "你在這裡",
          "attendance": "出席",
          "signupsLockedHint": "這個活動的報名已鎖定。",
          "alreadySignedUpHint": "你已經報名了另一個席位。要更換的話請先取消報名。",
          "slotTakenHint": "這個席位已經有人了。",
          "currentSlot": "目前席位",
          "currentSlotHint": "這是該筆報名目前所在的席位。",
          "takenBy": "已由 %{username} 佔用",
          "slotPickerHint": "為這筆報名挑選一個席位。已被佔用或無法使用的席位會停用。",
          "signupCtaHint": "報名參加這個活動 — 你可以現在挑選特定席位，或稍後讓管理員為你指派。",
          "noSlotYet": "尚未指派席位",
          "signupApproval": "報名審核",
          "signupStatuses": {
            "confirmed": "已確認",
            "tentative": "暫定",
            "interested": "有興趣",
            "pending": "等待審核",
            "withdrawn": "已取消報名"
          },
          "signupApprovals": {
            "direct": "直接加入",
            "confirmation_required": "需要確認"
          },
          "unassignedSignupsHint": "這些成員已經報名活動，但還沒有席位。請在下方為他們指派，或移除該筆報名。",
          "taken": "已佔用",
          "grantedRoles": "已授予的角色",
          "noEventAdminsYet": "尚無其他管理員或版主。",
          "creator": "活動建立者",
          "eventTeamHint": "授予其他成員這個活動的管理員或版主權限。管理員可以編輯活動，版主可以管理報名。",
          "eventRole": "角色",
          "eventRoles": {
            "admin": "管理員",
            "moderator": "版主"
          },
          "memberPicker": "成員",
          "spawnedEvents": "已產生的活動",
          "fromMission": "來自任務",
          "pickTemplate": "挑選範本",
          "pickTemplateHint": "可以選擇以任務為起點 — 其資訊、隊伍、飛船與席位會複製到活動中，活動也會連結回該任務。",
          "noTemplate": "不使用範本",
          "noTemplateHint": "從空白開始建立活動。",
          "pickTemplateLoadFailed": "無法載入艦隊的任務。",
          "pickTemplatePageFailed": "無法載入更多任務。",
          "pickTemplateSearch": "搜尋任務",
          "pickTemplateNonePublished": "艦隊進行中的任務尚未發佈。",
          "pickTemplateNoneActive": "艦隊沒有進行中的任務。",
          "pickTemplateNoMatch": "沒有與搜尋相符的已發佈任務。",
          "changeTemplate": "更換範本",
          "clearTemplate": "清除範本",
          "myVehicle": "我的載具",
          "selectVehicle": "選擇載具（選填）",
          "vehicleMismatchHint": "所選載具不符合這個席位的需求。",
          "noFittingInHangar": "你的機庫裡沒有符合這個席位的載具。你仍然可以不選載具直接報名。",
          "vehicleFitsHint": "會帶一艘符合這艘飛船的載具。",
          "notes": "備註",
          "upcomingTab": "即將舉行",
          "pastTab": "過去",
          "archivedTab": "已封存",
          "listTab": "清單",
          "calendarTab": "行事曆",
          "subscribeHint": "把行事曆訂閱網址複製到剪貼簿，方便你貼進行事曆應用程式。",
          "visibilities": {
            "members": "成員",
            "officers": "幹部",
            "fleet": "公開",
            "squadron": "僅中隊"
          },
          "statuses": {
            "draft": "草稿",
            "open": "開放報名",
            "locked": "報名已鎖定",
            "active": "進行中",
            "completed": "已完成",
            "cancelled": "已取消",
            "past": "已結束"
          },
          "tabs": {
            "basic": "基本資訊",
            "description": "描述與封面",
            "teams": "隊伍與飛船",
            "overview": "總覽",
            "settings": "設定"
          },
          "calendar": {
            "month": "月",
            "week": "週",
            "weekTitle": "%{date} 當週"
          },
          "repeats": "重複"
        },
        "contracts": {
          "tabs": {
            "details": "詳細資訊",
            "delivery": "運送",
            "crew": "船員與報酬",
            "goods": "貨物"
          },
          "title": "標題",
          "description": "描述",
          "reward": "報酬",
          "deadline": "截止時間",
          "crewLimit": "隊伍上限",
          "visibility": "可見性",
          "visibilities": {
            "members_only": "所有成員",
            "squadron_only": "僅中隊"
          },
          "reimburseExpenses": "報銷開支",
          "from": "取貨地點",
          "to": "交付地點",
          "toHint": "送往你自己庫存的交付會傳送給你，由你親自接收。",
          "toAuthorHint": "交付會傳送給 %{username}，由其接收。",
          "myHangarInventory": "%{name}（我的機庫）",
          "authorHangarInventory": "%{name}（%{username} 的機庫）",
          "destinationRemoved": "已不可用",
          "lead": "負責人",
          "pendingCrew": "等待加入",
          "minQuality": "最低品質 %{value}",
          "craftedAny": "已製作，任意品質",
          "craftedAtLeast": "已製作，至少 %{grades}",
          "craftedExact": "已製作，恰好 %{grades}",
          "pickedUp": "已取 %{quantity}",
          "itemCategory": "類別",
          "itemUnit": "單位",
          "itemQuantity": "數量",
          "kind": {
            "label": "類型",
            "transport": "運輸",
            "procurement": "採購",
            "crafting": "製造"
          },
          "state": {
            "draft": "草稿",
            "open": "開放",
            "in_progress": "進行中",
            "fulfilled": "已完成",
            "cancelled": "已取消",
            "expired": "已過期",
            "settled": "已結算"
          },
          "itemTypes": {
            "Commodity": "商品",
            "Component": "部件",
            "Equipment": "裝備"
          },
          "qualityMatch": "匹配方式",
          "exactQuality": "正好 %{value}",
          "qualityMatches": {
            "at_least": "至少",
            "exact": "正好"
          },
          "itemQuality": "品質",
          "titleHint": "可選——不填時合約以所需貨物命名",
          "postedBy": "發布者",
          "claimedBy": "接下者",
          "delivered": "已交付",
          "deliveredOf": "%{delivered} / %{requested} %{unit}",
          "views": {
            "open": "進行中",
            "closed": "已結束",
            "mine": "我的",
            "completed": "已完成"
          }
        }
      },
      "commodity": {
        "name": "名稱",
        "buyPrice": "買入",
        "sellPrice": "賣出",
        "retired": "已不在目前版本中",
        "containerSizes": "貨櫃尺寸（SCU）",
        "pieceVolume": "每件體積（SCU）",
        "consumable": "可消耗",
        "refinesInto": "精煉為",
        "refinedFrom": "精煉自",
        "availability": {
          "retired": "價格僅針對目錄所在的版本記錄，而該商品不在其中。",
          "craftedOnly": "沒有終端交易此商品 —— 它是一種製造材料。",
          "none": "我們所知的終端都不買賣此商品。"
        },
        "chart": {
          "buyHighest": "買入，最高",
          "buyAverage": "買入，平均",
          "buyLowest": "買入，最低",
          "sellHighest": "賣出，最高",
          "sellAverage": "賣出，平均",
          "sellLowest": "賣出，最低"
        },
        "types": {
          "agricultural_supply": "農業物資",
          "alloy": "合金",
          "consumer_goods": "消費品",
          "drink": "飲品",
          "food": "食品",
          "gas": "氣體",
          "hpmc": "HPMC",
          "manmade": "人造物",
          "medical_supply": "醫療物資",
          "metal": "金屬",
          "military_supply": "軍用物資",
          "mineral": "礦物",
          "natural": "天然物",
          "nonmetals": "非金屬",
          "plasma_fuel": "電漿燃料",
          "processed_goods": "加工品",
          "quantum_fuel": "量子燃料",
          "rmc": "RMC",
          "scrap": "廢料",
          "vice": "違禁品",
          "waste": "廢棄物"
        },
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "裝備類型",
        "itemType": "物品類型",
        "subType": "子類型",
        "weaponClass": "武器類別",
        "slot": "部位",
        "size": "尺寸",
        "grade": "等級",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "name": "名稱",
        "manufacturer": "製造商",
        "retired": "已不在目前版本中",
        "noMetrics": "該物品沒有記錄任何數據。",
        "availability": {
          "retired": "價格只針對目錄目前所在的版本記錄，而該物品不在其中。",
          "craftedOnly": "沒有終端出售此物品——它由下方的配方製造。",
          "none": "沒有終端買賣此物品。"
        },
        "stats": {
          "damageReduction": "傷害減免",
          "temperatureRating": "耐溫範圍",
          "radiationProtection": "輻射防護",
          "radiationScrubRate": "輻射清除速率",
          "gForceTolerance": "G力耐受",
          "carryingCapacity": "攜帶容量",
          "magazineSize": "彈匣容量",
          "rateOfFire": "射速",
          "range": "有效射程",
          "weaponClass": "武器類別",
          "coreCompatibility": "核心相容性",
          "backpackCompatibility": "背包相容性",
          "volume": "體積"
        },
        "sorts": {
          "damageReduction": "傷害減免",
          "radiationProtection": "輻射防護",
          "gForceTolerance": "G力耐受",
          "rateOfFire": "射速",
          "range": "射程",
          "storage": "容量",
          "volume": "體積"
        }
      },
      "notifications": {
        "inbox": "收件匣",
        "archive": "封存",
        "unreadOnly": "僅未讀",
        "status": "狀態",
        "type": "類型",
        "selectPrompt": "選擇一則通知來閱讀",
        "noBody": "這則通知沒有更多細節。",
        "archivesOn": "移至封存",
        "deletesOn": "刪除於"
      },
      "unlistedModel": {
        "linkHint": "%{identifier} 對應目錄中的哪艘飛船？建議來自匯出資料，可能有誤。"
      },
      "slug": "Slug",
      "inventories": {
        "source": "來源",
        "sources": {
          "vehicle": "飛船",
          "handMade": "手動建立"
        }
      },
      "inventoryItems": {
        "name": "名稱",
        "category": "分類",
        "entryType": "異動",
        "quantity": "數量",
        "quality": "品質",
        "notes": "備註",
        "itemType": "目錄",
        "categories": {
          "commodity": "商品",
          "component": "組件",
          "weapon": "武器",
          "equipment": "裝備",
          "ammunition": "彈藥",
          "consumable": "消耗品",
          "other": "其他"
        },
        "entryTypes": {
          "deposit": "存入",
          "withdrawal": "取出"
        },
        "units": {
          "scu": "SCU",
          "units": "個"
        }
      },
      "shipHistory": {
        "sales": "促銷歷史",
        "salesCount": "記錄的促銷",
        "lastSale": "最近一次促銷",
        "averageGap": "平均間隔",
        "days": "%{count} 天",
        "ongoing": "進行中",
        "priceHistory": "現金購買價歷史",
        "firstPriced": "首次定價",
        "priceRemoved": "價格已移除",
        "wishlist": "每月願望清單新增",
        "patchChanges": "更新改動",
        "notRecordedYet": "僅從開始記錄之日起統計，因此飛船可能尚無記錄。"
      },
      "buildCompare": {
        "from": "起始版本",
        "to": "目標版本",
        "appeared": "新增",
        "vanished": "移除",
        "changed": "變更",
        "notRecorded": "其中一個版本沒有記錄該目錄。",
        "needsTwoBuilds": "只記錄了一個版本，無法進行比較。",
        "pickTwoBuilds": "請選擇兩個不同的版本。",
        "failed": "無法比較這兩個版本。",
        "andMore": "還有 %{count} 項",
        "catalogues": {
          "components": "部件",
          "equipment": "裝備",
          "commodities": "商品",
          "models": "艦船"
        }
      },
      "dockAccess": {
        "ramp": "坡道",
        "lift": "升降機",
        "tractor_beam": "牽引光束"
      },
      "dockTypes": {
        "vehiclepad": "載具停放位",
        "garage": "車庫",
        "landingpad": "停機坪",
        "dockingport": "對接口",
        "hangar": "機庫",
        "cargogrid": "貨運格柵"
      },
      "payouts": {
        "currency": "貨幣",
        "archived": "已封存",
        "activeTours": "目前",
        "amount": "金額",
        "description": "說明",
        "entryType": "類型",
        "expense": "支出",
        "income": "收入",
        "participant": "誰",
        "notes": "備註",
        "occurredAt": "時間",
        "paid": "支出",
        "held": "持有",
        "share": "應得",
        "net": "餘額",
        "profit": "利潤",
        "totalIncome": "收入",
        "totalExpenses": "支出",
        "guest": "訪客",
        "username": "使用者名稱",
        "name": "名稱",
        "sends": "支付給",
        "receives": "收取",
        "settled": "已結算",
        "open": "進行中",
        "owes": "應付",
        "isOwed": "應收",
        "even": "已結清",
        "title": "標題",
        "fleet": "艦隊",
        "startsAt": "開始於",
        "inviteLink": "邀請連結",
        "participants": "人數",
        "weight": "權重",
        "shares": "份",
        "customWeight": "自訂權重",
        "preview": "預覽 · 結算前會變動",
        "joinRequestPending": "申請待處理",
        "payer": "付款方",
        "declineReason": "原因",
        "review": {
          "pending": "待審核",
          "approved": "已核准",
          "declined": "已拒絕"
        }
      },
      "shipSizes": {
        "extra_extra_small": "小型飛船 (XXS)",
        "extra_small": "超小型 (XS)",
        "small": "小型 (S)",
        "medium": "中型 (M)",
        "large": "大型 (L)",
        "extra_large": "超大型 (XL)",
        "capital": "主力艦 (C)"
      },
      "relationships": {
        "party": "名稱",
        "since": "自",
        "tabs": {
          "accepted": "已建立",
          "incoming": "收到的",
          "outgoing": "已發送",
          "ignored": "已忽略"
        },
        "user": {
          "handle": "使用者名稱"
        },
        "fleet": {
          "handle": "艦隊識別碼"
        },
        "requested": "請求已發送",
        "friend": "已是好友"
      },
      "blueprint": {
        "anyGrade": "任意品質",
        "crafter": {
          "title": "製作 · %{name}",
          "recipe": "藍圖 %{number}",
          "noRecipe": "目前版本中沒有該物品的藍圖。"
        },
        "name": "名稱",
        "craftTime": "製造時間",
        "slots": "槽位",
        "materials": "材料",
        "quality": "品質",
        "missionSlots": {
          "location": "地點",
          "objects": "目標物",
          "target": "目標",
          "ship": "飛船",
          "cargo": "貨物",
          "rank": "等級",
          "danger": "危險度",
          "contract": "合約",
          "other": "可變"
        },
        "missionSlotsHint": "‹尖括號› 內的內容由遊戲在提供合約時填入。",
        "atNeutral": "Q500 時為 %{value}",
        "whatYouGet": "成品屬性",
        "fromSlots": "%{count} 個槽位",
        "factorOnly": "僅係數 — 目錄中無該屬性數值",
        "heldIn": "存於",
        "heldOn": "存於",
        "fromHangar": "機庫",
        "makes": "產出",
        "makesA": "製造藍圖 · 產出",
        "makesUnknown": "製造藍圖 · 產出物不在任何目錄中",
        "retired": "已移除",
        "minQuality": "最低 %{quality}",
        "belowGate": "低於該槽位門檻 — 品質低於 %{quality} 的材料無法放入。",
        "unvalued": "受影響 — 遊戲未給出數值",
        "noStats": "該槽位不影響任何屬性 — 材料只需存在即可。",
        "noMaterials": "遊戲檔案未列出該藍圖的材料。",
        "setEverySlot": "設定所有槽位",
        "qualityAll": "全部槽位為 %{quality}",
        "qualityRange": "各槽位 %{from}–%{to}",
        "anyOf": "在這 %{total} 項中任選 %{count} 項",
        "scu": "%{amount} SCU",
        "pieces": "%{count}×",
        "whereItDrops": "取得途徑",
        "fleetOwners": "誰能製造",
        "ownedByCount": "%{count} 人擁有",
        "sourceSummary": "%{count} 個來源 · %{orgs} 個組織",
        "unattributed": "未標明組織",
        "minPoints": "%{points} 點起",
        "noKnownSource": "無已知來源",
        "noSourceLead": "沒有任務或場景會發放此藍圖。",
        "noSourceBody": "遊戲檔案未將其列入任何獎勵池，因此無從指引。",
        "empty": "沒有符合的藍圖。",
        "craftableTypes": {
          "Component": "部件",
          "Equipment": "裝備",
          "Commodity": "商品"
        },
        "alignments": {
          "lawful": "守法",
          "neutral": "中立",
          "outlaw": "非法"
        },
        "kinds": {
          "contract": "合約",
          "scenario": "場景"
        },
        "duration": {
          "hours": "%{count} 小時",
          "minutes": "%{count} 分",
          "seconds": "%{count} 秒"
        }
      },
      "gameMission": {
        "locationNamedInText": "簡報中提及",
        "locations": "任務地點",
        "locationKinds": {
          "surface": "在行星或衛星上",
          "space": "在太空中",
          "mixed": "行星、衛星或太空",
          "unknown": "地點未知"
        },
        "location": "地點",
        "cannotLand": {
          "surface": "%{ship} 無法降落：此合約位於行星或衛星上",
          "mixed": "可能會把 %{ship} 帶到它無法降落的行星或衛星"
        },
        "calculatedInGame": "由遊戲計算",
        "blueprints": "藍圖",
        "name": "名稱",
        "org": "發布方",
        "offeredBy": "發布方",
        "offeredByUnknown": "未註明委託方",
        "standing": "聲望",
        "kind": "類型",
        "kinds": {
          "career": "職業",
          "contract": "一次性"
        },
        "difficulty": "難度",
        "difficultyAxes": {
          "mechanicalSkill": "操作技巧",
          "mentalLoad": "心智負擔",
          "riskOfLoss": "損失風險",
          "gameKnowledge": "遊戲理解"
        },
        "alignments": {
          "lawful": "守法",
          "neutral": "中立",
          "outlaw": "不法"
        },
        "rewards": "獎勵",
        "rewardKinds": {
          "blueprint": "藍圖",
          "reputation": "聲望",
          "item": "物品",
          "badge": "徽章",
          "currency": "報酬"
        },
        "oneOfASet": "一組中的一件",
        "briefing": "任務簡報",
        "templatedNote": "標記的部分由遊戲在發布任務時填入。",
        "payoutNote": "報酬由遊戲在產生任務時計算，因此遊戲檔案只為少數合約寫明金額。",
        "noRewards": "遊戲檔案未為此任務寫明獎勵。",
        "unreleased": "未在正式版",
        "retired": "已移除"
      },
      "fleetDirectory": {
        "name": "艦隊",
        "memberCount": "成員",
        "createdAt": "最新",
        "language": "語言",
        "recruiting": "招募中",
        "notRecruiting": "未招募",
        "roleplay": "角色扮演",
        "rsiSid": "SID %{sid}"
      },
      "tour": {
        "step": "第 %{current} 步，共 %{total} 步"
      },
      "vehiclePlaque": {
        "style": "樣式",
        "styles": {
          "brass": "黃銅",
          "hud": "Fleetyards 介面",
          "gunmetal": "槍鐵色",
          "blueprint": "船塢藍圖",
          "salvage": "鉚接廢料",
          "glass": "磨砂玻璃",
          "carbon": "碳纖維與信號紅",
          "walnut": "胡桃木與黃銅",
          "neon": "派羅霓虹",
          "manufacturer": "製造商樣式"
        },
        "captain": "艦長",
        "captainInfo": "留空則使用你在公開機庫中顯示的名稱。",
        "registry": "註冊編號",
        "operationsGroup": "行動組",
        "title": "命名銘牌",
        "dedication": "獻詞",
        "dedicationVerse": "獻詞詩句",
        "dedicationVerseInfo": "選填。幾行詩句或祝福，滑鼠懸停或點按獻詞時顯示。",
        "launchedOn": "下水日期",
        "launchPort": "下水港口",
        "affiliation": "所屬"
      },
      "vehicleOverview": {
        "picture": "圖片",
        "pictureInfo": "取代預設渲染圖顯示，在你的公開機庫以及你分享此艦船的艦隊中也會顯示。",
        "ownPicture": "你的圖片",
        "serial": "序號 %{serial}",
        "since": "自 %{date} 起在機庫中",
        "logSummary": "%{count} 則條目 · %{public} 則公開",
        "cargoFill": "已裝載 %{stowed} / %{capacity} SCU",
        "cargoStowed": "已裝載 %{stowed} SCU",
        "cargoMeter": "貨艙裝載",
        "configuration": "配置",
        "noPaint": "標準塗裝",
        "ownedPaints": "你的塗裝",
        "availablePaints": "塗裝",
        "ownedPaintsCount": {
          "one": "%{count} 款塗裝",
          "other": "%{count} 款塗裝"
        },
        "visibility": "可見性",
        "showPublic": "在我的公開機庫中顯示",
        "showName": "顯示名稱",
        "fleets": "服役於",
        "status": "狀態",
        "searchPaints": "搜尋塗裝",
        "location": "位置",
        "noLocation": "未設定",
        "noGroups": "無分組",
        "planLoadout": "規劃配裝",
        "pictureUpload": "上傳",
        "pictureGallery": "圖庫",
        "stockPicture": "標準圖片",
        "waysToGetIt": "取得途徑"
      },
      "vehicleLog": {
        "entries": "日誌條目",
        "title": "標題",
        "loggedAt": "日期",
        "loggedAtPlaceholder": "現在",
        "body": "內容",
        "public": "在我的公開機庫中顯示",
        "publicShort": "公開",
        "publicByDefault": "新條目預設公開",
        "filters": {
          "all": "全部",
          "public": "公開",
          "private": "私密"
        },
        "entryCount": {
          "one": "%{count} 則條目",
          "other": "%{count} 則條目"
        },
        "privateShort": "私密",
        "stats": "日誌",
        "statsEntries": "條目",
        "statsPublic": "公開",
        "statsSince": "始於"
      },
      "vehicleEdit": {
        "tabs": {
          "general": "一般",
          "visibility": "可見性",
          "notifications": "通知",
          "names": "名稱",
          "groups": "分組",
          "picture": "圖片"
        }
      },
      "vehicleLoadout": {
        "tabs": {
          "paints": "塗裝",
          "modules": "模組",
          "upgrades": "附加組件",
          "weapons": "武器",
          "missiles": "飛彈",
          "shields": "護盾產生器",
          "powerPlants": "發電機",
          "coolers": "冷卻器",
          "quantumDrives": "量子引擎",
          "radar": "雷達",
          "lifeSupport": "生命維持",
          "flightBlades": "飛行刀片"
        },
        "comingSoon": "即將推出",
        "ownedModules": "你擁有的模組",
        "nothingFitted": "未裝配",
        "refused": {
          "title": "遊戲更新後已不再適配",
          "removedOnSave": "儲存時會將這些從配置中移除。",
          "editToReplace": "編輯配置以替換它們。",
          "badge": "已不再適配",
          "reasons": {
            "slot_unknown": "飛船已沒有此槽位",
            "parent_not_fitted": "其所在的部件已不存在",
            "module_not_in_slot": "該模組已不適配此槽位",
            "component_not_in_slot": "已不適配此槽位",
            "slot_not_editable": "飛船現已鎖定此槽位",
            "nothing_to_empty": "此槽位已沒有可移除的部件"
          }
        },
        "againstStock": "相對原廠飛船的變化",
        "crafted": "已製作",
        "craftedPart": "%{name}（已製作）",
        "fitted": "已裝配",
        "owned": "已擁有",
        "noSlots": "這艘艦船目前還沒有可在此裝配的內容",
        "unavailableModule": "模組已不可用",
        "noFigureChange": "不改變艦船的任何數值",
        "loadoutName": "配裝名稱",
        "linkBuild": "連結到在其他網站規劃的配置",
        "stock": "原廠",
        "notFlightReady": "只有可飛行的艦船才能使用配裝",
        "slots": {
          "default": "模組槽位",
          "front": "前方模組槽位",
          "rear": "後方模組槽位",
          "left": "左側模組槽位",
          "right": "右側模組槽位"
        },
        "unavailable": {
          "modules": "此艦船不支援模組",
          "upgrades": "此艦船沒有可用的附加組件"
        },
        "none": "無"
      },
      "loadoutPicker": {
        "emptySocket": "空",
        "search": "搜尋",
        "owned": "已擁有",
        "stock": "原廠",
        "manufacturer": "製造商",
        "sortName": "名稱",
        "count": "%{total} 個中的 %{count} 個",
        "total": {
          "one": "%{count} 個選項",
          "other": "%{count} 個選項"
        },
        "reset": "重設篩選",
        "leaveEmpty": "留空",
        "type": "類型",
        "fixedByShip": "艦船固定部件",
        "noOtherPart": "沒有其他可用部件",
        "changed": "已變更",
        "noMatches": "沒有符合項目",
        "close": "關閉"
      }
    }
  }
}
